// import React, { useContext, useEffect, useState } from "react";
// import axios from "axios";
// import {
//   FaEdit,
//   FaTrash,
//   FaChevronDown,
//   FaChevronUp,
//   FaEye,
//   FaPlusCircle,
//   FaReply,
//   FaCommentDots,
//   FaSearch,
//   FaTimes,
//   FaTicketAlt,
//   FaDownload,
//   FaCommentAlt,
//   FaList,
// } from "react-icons/fa";
// import { XMarkIcon } from "@heroicons/react/24/solid";
// import Select from "react-select";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";

// export default function TaskTableView({ refreshTrigger }) {
//   const { user } = useContext(AuthContext);
//   const [tasks, setTasks] = useState([]);
//   const [statuses, setStatuses] = useState([]);
//   const [labels, setLabels] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [expandedTask, setExpandedTask] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedTask, setSelectedTask] = useState(null);
//   const [statusUpdates, setStatusUpdates] = useState([]);
//   const [comments, setComments] = useState([]);
//   const [ticketDetails, setTicketDetails] = useState(null);
//   const [isCommentBoxOpen, setIsCommentBoxOpen] = useState(false);
//   const [newComment, setNewComment] = useState("");
//   const [editModalOpen, setEditModalOpen] = useState(false);
//   const [editedTask, setEditedTask] = useState({});
//   const [isResponseModalOpen, setIsResponseModalOpen] = useState(false);
//   const [responseData, setResponseData] = useState({ content: "", file: null });
//   const [taskResponses, setTaskResponses] = useState([]);
//   const [isViewModalOpen, setIsViewModalOpen] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [taskToDelete, setTaskToDelete] = useState(null);
//   const [searchParams, setSearchParams] = useState({
//     subject: "",
//     priority: "",
//     labelName: "",
//     targetUserId: "",
//     startDate: "",
//     endDate: "",
//   });
//   const [isSearching, setIsSearching] = useState(false);
//   const [showFields, setShowFields] = useState(false);
//   const [showAttachmentModal, setShowAttachmentModal] = useState(false);
//   const [currentAttachment, setCurrentAttachment] = useState(null);
//   const [attachmentType, setAttachmentType] = useState("");
//   const [attachmentFilename, setAttachmentFilename] = useState("");
//   const [pageNumber, setPageNumber] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalPages, setTotalPages] = useState(0);
//   const [abortController, setAbortController] = useState(new AbortController());
//   const [isLoading, setIsLoading] = useState(false);
//   const [editModalData, setEditModalData] = useState(null); // response to edit
//   const [updatedContent, setUpdatedContent] = useState("");
//   const [updatedFile, setUpdatedFile] = useState(null);
//   const [currentResponseFile, setCurrentResponseFile] = useState(null);
//   const [responseFileModalOpen, setResponseFileModalOpen] = useState(false);
//   const [remarkInput, setRemarkInput] = useState("");
//   const [actionType, setActionType] = useState(""); // "APPROVED" or "REJECTED"
//   const [showRemarkInput, setShowRemarkInput] = useState(false);
//   const [editingCommentId, setEditingCommentId] = useState(null);
//   const [editedComment, setEditedComment] = useState("");
//   const [showCommentBoxId, setShowCommentBoxId] = useState(null);
//   const [commentInput, setCommentInput] = useState("");
//   const [editingComment, setEditingComment] = useState(null);
//   const token = localStorage.getItem("token");
//   const [statusUpdateModalOpen, setStatusUpdateModalOpen] = useState(false);
//   const [commentLengthError, setCommentLengthError] = useState("");
//   const [selectedStatusUpdate, setSelectedStatusUpdate] = useState({
//     taskId: null,
//     newStatus: "",
//     remark: "",
//   });
//   const [participantEmail, setParticipantEmail] = useState("");
//   const [showNotifyModal, setShowNotifyModal] = useState(false);
//   const [pendingParticipant, setPendingParticipant] = useState(null);
//   const [participants, setParticipants] = useState([]);
//   const [taskDetailsModalOpen, setTaskDetailsModalOpen] = useState(false);

//   // Fetch Statuses & Labels
//   useEffect(() => {
//     async function fetchStatusAndLabel() {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;
//       // if (!companyId) return;

//       try {
//         const statusResponse = await axios.get(
//           `${API_URL}/api/taskStatus/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           },
//         );

//         const labelResponse = await axios.get(
//           `${API_URL}/api/taskLabel/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           },
//         );

//         setStatuses(statusResponse.data);
//         setLabels(labelResponse.data);
//       } catch (error) {
//         console.error("Error fetching statuses and labels:", error);
//       }
//     }
//     fetchStatusAndLabel();
//   }, [user]);

//   // Fetch Users
//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       const url =
//         user?.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await axios.get(url, {
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });
//         setUsers(response.data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }
//     fetchUsers();
//   }, [user]);

//   const handleEditClick = (task) => {
//     setEditedTask({
//       ...task,
//       assignedToJson: JSON.stringify(task.assignedTo),
//     });
//     const participantEmails =
//       task.participants?.map((p) => (Array.isArray(p) ? p[1] || p[0] : p)) ||
//       [];
//     setParticipants(participantEmails);
//     setEditModalOpen(true);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditedTask((prev) => ({ ...prev, [name]: value }));
//     setResponseData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleStatusChange = async (taskId, newStatus) => {
//     setSelectedStatusUpdate({
//       taskId,
//       newStatus,
//       remark: "",
//     });
//     setStatusUpdateModalOpen(true);
//   };

//   // Add this function to submit the status update
//   const handleStatusUpdateSubmit = async () => {
//     if (!selectedStatusUpdate.remark.trim()) {
//       toast.error("Please enter a remark");
//       return;
//     }

//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.put(
//         `${API_URL}/api/tasks/updateStatus/${selectedStatusUpdate.taskId}`,
//         {
//           newStatus: selectedStatusUpdate.newStatus,
//           remark: selectedStatusUpdate.remark,
//           updatedById: user.id,
//           updatedByName: user.name,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       if (response.data.status === "Successful") {
//         toast.success(response.data.message);
//         setStatusUpdateModalOpen(false);
//         fetchPage(pageNumber); // Refresh the current page
//       } else {
//         throw new Error(response.data.message);
//       }
//     } catch (error) {
//       console.error("Error updating task status:", error);
//       toast.error(error.response?.data?.message);
//     }
//   };

//   const handleLabelChange = (e) => {
//     const selectedLabel = labels.find((label) => label.name === e.target.value);
//     setEditedTask((prev) => ({
//       ...prev,
//       labelName: e.target.value,
//       labelColor: selectedLabel ? selectedLabel.color : "",
//     }));
//   };

//   const handleAssignedUsersChange = (selectedOptions) => {
//     const assignedUsers = selectedOptions.map((option) => ({
//       id: option.value,
//       name: option.label,
//     }));
//     setEditedTask((prev) => ({
//       ...prev,
//       assignedToJson: JSON.stringify(assignedUsers),
//     }));
//   };

//   // In your edit modal's form, ensure all required fields are properly handled
//   const handleUpdateSubmit = async (e) => {
//     e.preventDefault();

//     // Add validation if needed
//     if (!editedTask.subject) {
//       toast.error("Subject is required");
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append("subject", editedTask.subject);
//       formData.append("priority", editedTask.priority || "Low");
//       if (editedTask.labelName)
//         formData.append("labelName", editedTask.labelName);
//       if (editedTask.labelColor)
//         formData.append("labelColor", editedTask.labelColor);
//       if (editedTask.endDate) formData.append("endDate", editedTask.endDate);
//       if (editedTask.description)
//         formData.append("description", editedTask.description);
//       if (editedTask.assignedToJson)
//         formData.append("assignedToJson", editedTask.assignedToJson);
//       if (editedTask.file) formData.append("file", editedTask.file);
//       participants.forEach((participant) => {
//         const value = Array.isArray(participant)
//           ? participant[1] || participant[0]
//           : participant;
//         formData.append("participants", value.trim());
//       });

//       const response = await axios.put(
//         `${API_URL}/api/tasks/${editedTask.taskId}/updatedBy/${user.id}/updatedByName/${user.name}`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "multipart/form-data",
//           },
//         },
//       );

//       toast.success(response.data.message);
//       setEditModalOpen(false);
//       fetchPage(pageNumber); // Refresh the first page
//     } catch (error) {
//       console.error("Error updating task:", error);
//       toast.error(error.response?.data?.message);
//     }
//   };

//   // Handle search input changes
//   const handleSearchChange = (e) => {
//     const { name, value } = e.target;
//     setSearchParams((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Handle search submit
//   const handleSearchSubmit = async (e) => {
//     e.preventDefault();
//     setIsSearching(true);
//     setPageNumber(0);

//     try {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;
//       if (!companyId) return;

//       // Remove empty params
//       const params = Object.fromEntries(
//         Object.entries(searchParams).filter(([_, v]) => v !== ""),
//       );

//       // Add pagination parameters
//       params.pageNumber = pageNumber;
//       params.pageSize = pageSize;

//       const response = await axios.get(
//         `${API_URL}/api/tasks/search/${companyId}/${user?.id}`,
//         {
//           params,
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );

//       setTasks(response.data.tasks || []);
//       setTotalPages(response.data?.totalPages || 0);
//       toast.success(`Found ${response.data?.tasks?.length || 0} results`);
//     } catch (error) {
//       console.error("Search failed:", error);
//       toast.error("Failed to search tasks");
//       setTasks([]);
//       setTotalPages(0);
//     }
//   };

//   // Clear search and reset to normal view
//   const handleClearSearch = () => {
//     setIsSearching(false);
//     setSearchParams({
//       subject: "",
//       priority: "",
//       labelName: "",
//       targetUserId: "",
//       startDate: "",
//       endDate: "",
//     });
//     setPageNumber(0);
//     fetchPage(0);
//   };

//   const fetchPage = async (page) => {
//     setIsLoading(true);

//     // Cancel any pending requests
//     abortController.abort();
//     const newAbortController = new AbortController();
//     setAbortController(newAbortController);

//     try {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         toast.error("Authentication token missing");
//         return;
//       }

//       let response;
//       const params = {
//         pageNumber: page,
//         pageSize: pageSize,
//       };

//       if (isSearching) {
//         const companyId =
//           user?.accountType === "COMPANY" ? user.id : user?.companyId;
//         // Add search params
//         Object.entries(searchParams).forEach(([key, value]) => {
//           if (value) params[key] = value;
//         });

//         response = await axios.get(
//           `${API_URL}/api/tasks/search/${companyId}/${user?.id}`,
//           {
//             params,
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//             signal: newAbortController.signal,
//           },
//         );
//       } else {
//         let endpoint = "";
//         if (!user?.id) return;

//         if (user.accountType === "COMPANY") {
//           endpoint = `${API_URL}/api/tasks/company/${user.id}`;
//         } else {
//           endpoint = `${API_URL}/api/tasks/forUser/${user.id}`;
//         }

//         response = await axios.get(
//           `${endpoint}?pageNumber=${page}&pageSize=${pageSize}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//             signal: newAbortController.signal,
//           },
//         );
//       }

//       // Handle response
//       const tasks = Array.isArray(response.data?.tasks)
//         ? response.data.tasks
//         : [];
//       const total = response.data?.totalPages || 0;

//       setTasks(tasks);
//       setTotalPages(total);
//       setPageNumber(page);
//     } catch (err) {
//       if (err.name === "AbortError" || axios.isCancel(err)) return;
//       console.error("Error fetching tasks:", err);
//       setTasks([]);
//       setTotalPages(0);
//       toast.error(err.response?.data?.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     const handleTaskCreated = () => {
//       // Your data fetching logic here
//       setPageNumber(0);
//       fetchPage(0);
//     };

//     window.addEventListener("taskCreated", handleTaskCreated);

//     return () => {
//       window.removeEventListener("taskCreated", handleTaskCreated);
//     };
//   }, []);

//   useEffect(() => {
//     const controller = new AbortController();
//     setAbortController(controller);

//     setPageNumber(0);
//     fetchPage(0);

//     return () => {
//       controller.abort();
//     };
//   }, [pageSize, isSearching, refreshTrigger, user]);

//   const toggleDropdown = (taskId) => {
//     setExpandedTask(expandedTask === taskId ? null : taskId);
//   };

//   const handleViewTicket = async (task) => {
//     setSelectedTask(task);
//     setIsModalOpen(true);

//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         `${API_URL}/api/tickets/by-reference/${task.taskId}?referenceType=TASK`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );

//       const ticketData = response.data;
//       setTicketDetails(ticketData);

//       setComments(ticketData.comments || []);
//       setStatusUpdates(task.statusUpdates || []);
//     } catch (error) {
//       console.error("Error fetching ticket details:", error);
//     }
//   };

//   const handleAddComment = async () => {
//     if (newComment.trim().length > 150) {
//       setCommentLengthError("comment must not exceed 150 characters");
//       return;
//     }

//     try {
//       await axios.post(
//         `${API_URL}/api/tickets/addComment/${ticketDetails.ticketId}`,
//         {
//           userId: user.id,
//           userName: user.name,
//           content: newComment,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );
//       setComments((prev) => [
//         ...prev,
//         {
//           content: newComment,
//           userName: user.name,
//           createdAt: new Date().toISOString(),
//         },
//       ]);
//       handleViewTicket();
//       setNewComment("");
//       setCommentLengthError("");
//       setIsCommentBoxOpen(false);
//     } catch (error) {
//       console.error("Failed to post comment:", error);
//     }
//   };

//   const handleCloseButton = () => {
//     setIsModalOpen(false);
//     setIsCommentBoxOpen(false);
//     setNewComment("");
//   };

//   const handleResponseClick = (task) => {
//     setSelectedTask(task);
//     setIsResponseModalOpen(true);
//   };

//   const handleFileChange = (e) => {
//     setResponseData((prev) => ({ ...prev, file: e.target.files[0] }));
//   };

//   const handleResponseSubmit = async () => {
//     if (!selectedTask) {
//       toast.error("No task selected.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("content", responseData.content);
//     formData.append("userId", user?.id);
//     formData.append("userName", user?.name);
//     if (responseData.file) {
//       formData.append("file", responseData.file);
//     }

//     try {
//       const res = await fetch(
//         `${API_URL}/api/tasks/addResponse/${selectedTask?.taskId}`,
//         {
//           method: "POST",
//           body: formData,
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );

//       const responseData = await res.json(); // Add this line to parse the JSON response

//       if (res.ok) {
//         toast.success(responseData.message); // Use responseData instead of response
//         setIsResponseModalOpen(false);
//         setResponseData({ content: "", file: null });
//         handleViewResponse(selectedTask.taskId);
//       } else {
//         toast.error("Failed to submit response.");
//       }
//     } catch (err) {
//       console.error("Error submitting response:", err);
//       toast.error("Something went wrong while submitting response.");
//     }
//   };

//   const handleViewResponse = async (clickedTaskId) => {
//     try {
//       const endpoint =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/tasks/company/${user.id}`
//           : `${API_URL}/api/tasks/forUser/${user.id}`;

//       const response = await axios.get(endpoint, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           "Content-Type": "application/json",
//         },
//       });

//       const allTasks = Array.isArray(response.data.tasks)
//         ? response.data.tasks
//         : [];

//       // Find the selected task using taskId
//       const foundTask = allTasks.find((task) => task.taskId === clickedTaskId);
//       if (!foundTask) return;

//       // Set the task and its responses from task object
//       setSelectedTask(foundTask);
//       setTaskResponses(foundTask.taskResponse || []);

//       // Open modal
//       setIsViewModalOpen(true);
//     } catch (error) {
//       console.error("Error in handleViewResponse:", error);
//     }
//   };

//   const handleDeleteResponse = async (responseId, taskId) => {
//     try {
//       await axios.delete(
//         `${API_URL}/api/tasks/deleteResponse/${selectedTask.taskId}/${responseId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );

//       // Refetch tasks after delete to keep UI updated
//       handleViewResponse(selectedTask.taskId);
//     } catch (error) {
//       console.error("Error deleting response:", error);
//     }
//   };

//   const handleDeleteTask = async (taskId) => {
//     try {
//       await axios.delete(`${API_URL}/api/tasks/deleteTask/${taskId}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });

//       toast.success("Task deleted successfully");
//       setShowDeleteModal(false);
//       setTaskToDelete(null);
//       fetchPage(0); // refresh task list
//     } catch (error) {
//       console.error("Delete failed:", error);
//       toast.error(error.response?.data?.message || "Failed to delete task");
//     }
//   };

//   const handleViewAttachment = async (task) => {
//     try {
//       if (!task.attachment || task.attachment === "null") {
//         toast.error("No attachment found");
//         return;
//       }

//       const filename = task.attachment;
//       const fileExtension = filename.split(".").pop().toLowerCase();

//       // Determine type category
//       let typeCategory = "other";
//       if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
//         typeCategory = "image";
//       } else if (["mp4", "webm", "ogg"].includes(fileExtension)) {
//         typeCategory = "video";
//       } else if (["mp3", "wav", "ogg"].includes(fileExtension)) {
//         typeCategory = "audio";
//       } else if (fileExtension === "pdf") {
//         typeCategory = "pdf";
//       } else if (
//         ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)
//       ) {
//         typeCategory = "unsupported";
//       } else if (["txt", "csv"].includes(fileExtension)) {
//         typeCategory = "text";
//       }

//       // Show error for unsupported types
//       if (typeCategory === "unsupported") {
//         toast.error("Preview not available for this file type");
//         return;
//       }

//       // Fetch file
//       const response = await axios.get(
//         `${API_URL}/api/tasks/view/${task.taskId}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );

//       // Create object URL
//       const blobType =
//         typeCategory === "pdf" ? "application/pdf" : response.data.type;
//       const blob = new Blob([response.data], { type: blobType });
//       const fileUrl = URL.createObjectURL(blob);

//       // If PDF on mobile, open in new tab instead of modal
//       const isMobile = window.innerWidth < 768;
//       if (typeCategory === "pdf" && isMobile) {
//         window.open(fileUrl, "_blank");
//         return;
//       }

//       setCurrentAttachment(fileUrl);
//       setAttachmentFilename(filename);
//       setAttachmentType(typeCategory);
//       setShowAttachmentModal(true);
//     } catch (error) {
//       toast.error("Failed to view attachment");
//       console.error(error);
//     }
//   };

//   const handleDownloadAttachment = async (task) => {
//     try {
//       if (!task.attachment || task.attachment === "null") {
//         toast.error("No attachment found");
//         return;
//       }

//       const response = await axios.get(
//         `${API_URL}/api/tasks/download/${task.taskId}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );

//       // Use the filename from the task's attachment field
//       const filename = task.attachment;

//       const blob = new Blob([response.data]);
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       toast.error("Failed to download attachment");
//       console.error(error);
//     }
//   };

//   const getOfficeViewerUrl = (fileUrl) => {
//     return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
//       fileUrl,
//     )}`;
//   };

//   // const handleTabChange = (tab) => {
//   //   setActiveTab(tab);
//   //   setPageNumber(0); // Reset to first page
//   //   setIsSearching(false); // Clear any search state
//   //   setTasks([]);
//   // };

//   const handleViewFile = async (res) => {
//     try {
//       if (!res.attachment || res.attachment === "null") {
//         toast.error("No attachment found");
//         return;
//       }

//       const taskId = selectedTask?.taskId;
//       const filename = res.attachment;
//       const fileExtension = filename.split(".").pop().toLowerCase();

//       // Determine type category (same as handleViewAttachment)
//       let typeCategory = "other";
//       if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
//         typeCategory = "image";
//       } else if (["mp4", "webm", "ogg"].includes(fileExtension)) {
//         typeCategory = "video";
//       } else if (["mp3", "wav", "ogg"].includes(fileExtension)) {
//         typeCategory = "audio";
//       } else if (fileExtension === "pdf") {
//         typeCategory = "pdf";
//       } else if (
//         ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)
//       ) {
//         typeCategory = "office";
//       } else if (["txt", "csv"].includes(fileExtension)) {
//         typeCategory = "text";
//       }

//       // Show error for unsupported types
//       if (typeCategory === "unsupported") {
//         toast.error("Preview not available for this file type");
//         return;
//       }

//       // Fetch file
//       const response = await axios.get(
//         `${API_URL}/api/tasks/viewResponseFile/${taskId}/${res.id}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );

//       // Create object URL
//       const blobType =
//         typeCategory === "pdf" ? "application/pdf" : response.data.type;
//       const blob = new Blob([response.data], { type: blobType });
//       const fileUrl = URL.createObjectURL(blob);

//       // If PDF on mobile, open in new tab instead of modal
//       const isMobile = window.innerWidth < 768;
//       if (typeCategory === "pdf" && isMobile) {
//         window.open(fileUrl, "_blank");
//         return;
//       }

//       setCurrentResponseFile({
//         url: fileUrl,
//         type: typeCategory,
//         name: filename,
//       });
//       setResponseFileModalOpen(true);
//     } catch (error) {
//       console.error("Error viewing file:", error);
//       toast.error(
//         "Failed to view attachment. You can try downloading it instead.",
//       );
//     }
//   };

//   const handleDownloadFile = async (res) => {
//     try {
//       if (!res.attachment || res.attachment === "null") {
//         toast.error("No attachment found");
//         return;
//       }

//       const taskId = selectedTask?.taskId;
//       const response = await axios.get(
//         `${API_URL}/api/tasks/downloadResponseFile/${taskId}/${res.id}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );

//       // Get filename from Content-Disposition header or use the stored filename
//       const contentDisposition = response.headers["content-disposition"];
//       let filename = res.attachment;
//       if (contentDisposition) {
//         const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
//         if (filenameMatch && filenameMatch[1]) {
//           filename = filenameMatch[1];
//         }
//       }

//       const blob = new Blob([response.data]);
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Error downloading file:", error);
//       toast.error("Failed to download attachment");
//     }
//   };

//   const handleEditResponse = (res) => {
//     setEditModalData(res);
//     setUpdatedContent(res.content);
//     setUpdatedFile(null); // clear previous file if any
//   };

//   const handleUpdateResponse = async () => {
//     const formData = new FormData();
//     if (updatedFile) formData.append("file", updatedFile);

//     formData.append("taskId", selectedTask.taskId);
//     formData.append("userId", user.id);
//     formData.append("userName", user.name);
//     formData.append("content", updatedContent);

//     try {
//       await axios.put(
//         `${API_URL}/api/tasks/updateResponse/${editModalData.id}`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "multipart/form-data",
//           },
//         },
//       );

//       setEditModalData(null);
//       setUpdatedContent("");
//       setUpdatedFile(null);

//       handleViewResponse(selectedTask.taskId); // refresh list
//     } catch (err) {
//       console.error("Error updating response:", err);
//     }
//   };

//   const handleApproveOrReject = async (taskId, newStatus, remark) => {
//     try {
//       const token = localStorage.getItem("token");

//       const response = await fetch(
//         `${API_URL}/api/tasks/approveOrReject/${taskId}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({
//             newStatus,
//             updatedById: user?.id,
//             updatedByName: user?.name,
//             remark,
//           }),
//         },
//       );

//       if (response.ok) {
//         // 1. Clear remark input
//         setRemarkInput("");

//         // 2. Close remark input UI
//         setShowRemarkInput(false);

//         // 3. Close modal
//         setIsModalOpen(false);

//         // 4. Update local state immediately
//         setSelectedTask((prev) => ({
//           ...prev,
//           statusName: newStatus,
//           statusColor:
//             newStatus === "APPROVED"
//               ? "#10b981"
//               : newStatus === "REJECTED"
//                 ? "#ef4444"
//                 : "#e5e7eb",
//           statusUpdates: [
//             ...(prev.statusUpdates || []),
//             {
//               newStatus,
//               updatedAt: new Date().toISOString(),
//               updatedByName: user?.name,
//               remark,
//             },
//           ],
//         }));

//         // 5. Show success notification
//         toast.success(`Ticket ${newStatus.toLowerCase()} successfully!`);
//         handleViewTicket();
//         fetchPage(pageNumber);
//       } else {
//         toast.error("Failed to update task status");
//         console.error("Failed to update task status");
//       }
//     } catch (error) {
//       toast.error("Error updating ticket status");
//       console.error("Error:", error);
//     }
//   };

//   const handleUpdateComment = async (ticketId, commentId, updatedContent) => {
//     const token = localStorage.getItem("token");

//     try {
//       const response = await axios.put(
//         `${API_URL}/api/tickets/updateComment/${ticketId}/${commentId}`,
//         updatedContent,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "text/plain",
//           },
//         },
//       );

//       // Clear editing state
//       setEditingCommentId(null);
//       setEditedComment("");

//       // Update comments list
//       const ticketData = response.data;
//       setTicketDetails(ticketData);
//       setComments(ticketData.comments || []);

//       toast.success("Comment updated successfully");
//     } catch (error) {
//       console.error("Error updating comment:", error);
//       toast.error("Failed to update comment");
//     }
//   };

//   const handleDeleteComment = async (commentId) => {
//     const token = localStorage.getItem("token");

//     try {
//       const response = await axios.delete(
//         `${API_URL}/api/tickets/deleteComment/${ticketDetails.ticketId}/${commentId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       const ticketData = response.data;
//       setTicketDetails(ticketData);
//       setComments(ticketData.comments || []);
//     } catch (error) {
//       console.error("Error deleting comment:", error);
//     }
//   };

//   const toggleCommentBox = (responseId) => {
//     if (showCommentBoxId === responseId) {
//       setShowCommentBoxId(null);
//       setCommentInput("");
//       setEditingComment(null);
//     } else {
//       setShowCommentBoxId(responseId);
//       setCommentInput("");
//       setEditingComment(null);
//     }
//   };

//   // Submit or update comment
//   const submitComment = async (responseId) => {
//     if (!commentInput.trim()) return;
//     const commentId = editingComment?.commentId;

//     try {
//       const url = editingComment
//         ? `${API_URL}/api/tasks/updateResponseComment/${selectedTask.taskId}/${responseId}/${commentId}`
//         : `${API_URL}/api/tasks/addResponseComment/${selectedTask.taskId}/${responseId}`;

//       const method = editingComment ? "PUT" : "POST";

//       const bodyData = {
//         content: commentInput,
//         userId: user?.id,
//         userName: user?.name,
//       };

//       const res = await fetch(url, {
//         method,
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: editingComment ? commentInput : JSON.stringify(bodyData),
//       });

//       if (res.ok) {
//         setCommentInput("");
//         setShowCommentBoxId(null);
//         setEditingComment(null);
//         handleViewResponse(selectedTask.taskId);
//         toast.success(editingComment ? "Comment updated!" : "Comment added!");
//       }
//     } catch (error) {
//       console.error("Error submitting comment:", error);
//     }
//   };

//   // Start editing
//   const handleEditComment = (responseId, comment) => {
//     setShowCommentBoxId(responseId);
//     setCommentInput(comment.content);
//     setEditingComment(comment);
//   };

//   // Delete comment
//   const handleDeleteResponseComment = async (responseId, commentId) => {
//     try {
//       const res = await fetch(
//         `${API_URL}/api/tasks/deleteResponseComment/${selectedTask.taskId}/${responseId}/${commentId}`,
//         {
//           method: "DELETE",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );
//       if (res.ok) {
//         await handleViewResponse(selectedTask.taskId);
//         toast.success("Comment deleted!");
//       }
//     } catch (error) {
//       console.error("Error deleting comment:", error);
//     }
//   };

//   // Update the participant handling functions
//   const handleAddParticipant = () => {
//     if (!participantEmail) return;

//     const matchedUser = users.find((u) => u.email === participantEmail);
//     if (matchedUser) {
//       setPendingParticipant({ id: matchedUser.id, email: participantEmail });
//       setShowNotifyModal(true);
//     } else {
//       setParticipants((prev) => [...prev, participantEmail]);
//       setParticipantEmail("");
//     }
//   };

//   const confirmParticipant = (type) => {
//     let entry =
//       type === "both"
//         ? [pendingParticipant.id, pendingParticipant.email]
//         : [pendingParticipant.email];

//     setParticipants((prev) => [...prev, entry]);
//     setShowNotifyModal(false);
//     setPendingParticipant(null);
//     setParticipantEmail("");
//   };

//   const handleViewTaskDetails = (task) => {
//     setSelectedTask(task);
//     setTaskDetailsModalOpen(true);
//   };

//   // helper section for rendering for the date and  n formate of the DD-MM-YYYY adding date 27-01-2026
//   const formatDate = (date) => {
//     if (!date) return "-";
//     const d = new Date(date);
//     const day = String(d.getDate()).padStart(2, "0");
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const year = d.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   return (
//     <div className="p-2 dark:bg-gray-900 dark:text-gray-100">
//       <div className="flex flex-col gap-4 mb-4 sm:flex-row sm:justify-between sm:items-center">
//         {/* Heading: top on small, left on large */}
//         <div className="flex justify-start">
//           <h2 className="text-xl font-bold">Task Table</h2>
//         </div>

//         {/* Search button: center on mobile, right on large */}
//         <div className="flex flex-wrap justify-end">
//           <button
//             type="button"
//             onClick={() => setShowFields(!showFields)}
//             className="px-2 py-1 bg-indigo-600 text-white hover:bg-indigo-700 rounded flex items-center"
//           >
//             {showFields ? (
//               <>
//                 <FaTimes className="mr-2 w-5 h-4" />
//                 Close
//               </>
//             ) : (
//               <>
//                 <FaSearch className="mr-2 w-5 h-4" />
//                 Search
//               </>
//             )}
//           </button>
//         </div>
//       </div>

//       {showFields && (
//         <form
//           onSubmit={handleSearchSubmit}
//           className="p-2 bg-white dark:bg-gray-800 shadow rounded-md mb-4"
//         >
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 items-end">
//             {/* Subject */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                 Subject
//               </label>
//               <input
//                 type="text"
//                 name="subject"
//                 value={searchParams.subject}
//                 onChange={handleSearchChange}
//                 placeholder="Search by subject"
//                 className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//               />
//             </div>

//             {/* Priority */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                 Priority
//               </label>
//               <select
//                 name="priority"
//                 value={searchParams.priority}
//                 onChange={handleSearchChange}
//                 className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//               >
//                 <option value="">All</option>
//                 <option value="High">High</option>
//                 <option value="Medium">Medium</option>
//                 <option value="Low">Low</option>
//               </select>
//             </div>

//             {/* Label */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                 Label
//               </label>
//               <select
//                 name="labelName"
//                 value={searchParams.labelName}
//                 onChange={handleSearchChange}
//                 className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//               >
//                 <option value="">All</option>
//                 {labels.map((label) => (
//                   <option key={label.id} value={label.name}>
//                     {label.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Created By */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                 User
//               </label>
//               <select
//                 name="targetUserId"
//                 value={searchParams.targetUserId}
//                 onChange={handleSearchChange}
//                 className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//               >
//                 <option value="">All</option>
//                 {users.map((user) => (
//                   <option key={user.id} value={user.id}>
//                     {user.fname} {user.lname}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Date Range */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                 Date Range
//               </label>
//               <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
//                 <input
//                   type="date"
//                   name="startDate"
//                   value={searchParams.startDate}
//                   onChange={handleSearchChange}
//                   className="sm:w-1/2 mb-2 sm:mb-0 p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                 />
//                 <span className="text-center sm:text-left text-gray-500 dark:text-gray-300">
//                   to
//                 </span>
//                 <input
//                   type="date"
//                   name="endDate"
//                   value={searchParams.endDate}
//                   onChange={handleSearchChange}
//                   className="sm:w-1/2 mt-2 sm:mt-0 p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="flex justify-end space-x-2 mt-2">
//             <button
//               type="submit"
//               className="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
//             >
//               <FaSearch className="mr-2" />
//               Search
//             </button>
//             {isSearching && (
//               <button
//                 type="button"
//                 onClick={handleClearSearch}
//                 className="px-2 py-1 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 flex items-center"
//               >
//                 <FaTimes className="mr-2" />
//                 Clear
//               </button>
//             )}
//           </div>
//         </form>
//       )}

//       <div className="overflow-x-auto">
//         <table className="w-full border-collapse border border-gray-300 dark:border-gray-600 text-xs">
//           <thead>
//             <tr className="bg-gray-100 dark:bg-gray-700 dark:text-white text-left">
//               <th className="p-1">S No.</th>
//               <th className="p-1">Subject</th>
//               <th className="p-1">Priority</th>
//               <th className="p-1">Assigned Date</th>
//               <th className="p-1">End Date</th>
//               <th className="p-1">Assigned By</th>
//               <th className="p-1">Assigned To</th>

//               <th className="p-1">Status</th>
//               <th className="p-1">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {isLoading ? (
//               <tr>
//                 <td colSpan="9" className="text-center p-4">
//                   Loading...
//                 </td>
//               </tr>
//             ) : tasks.length > 0 ? (
//               tasks.map((task, index) => (
//                 <React.Fragment key={task.taskId}>
//                   <tr className="border-b border-gray-300 dark:border-gray-600 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700">
//                     <td className="p-1">
//                       <div className="flex items-center gap-2">
//                         {index + 1}.
//                         <FaList
//                           className="text-blue-500 cursor-pointer hover:text-blue-700"
//                           onClick={() => handleViewTaskDetails(task)}
//                           title="View task details"
//                         />
//                       </div>
//                     </td>
//                     <td className="p-1 flex items-center   justify-between">
//                       {/* <span>{task.subject}</span> */}
//                       <span
//                         className="max-w-[190px] truncate cursor-pointer"
//                         title={task.subject}
//                       >
//                         {task.subject}
//                       </span>
//                       <span
//                         onClick={() => toggleDropdown(task.taskId)}
//                         className="ml-2 cursor-pointer"
//                       >
//                         {expandedTask === task.taskId ? (
//                           <FaChevronUp className="text-gray-500" />
//                         ) : (
//                           <FaChevronDown className="text-gray-500" />
//                         )}
//                       </span>
//                     </td>
//                     <td className="p-1">{task.priority}</td>
//                     {/* <td className="p-1">{task.startDate}</td> */}
//                     {/* <td className="p-1">{task.endDate}</td> */}
//                     <td className="p-1">{formatDate(task.startDate)}</td>
//                     <td className="p-1">{formatDate(task.endDate)}</td>

//                     <td className="p-1">{task.createdByName}</td>
//                     <td className="p-1">
//                       {task.assignedTo.map((assignee, idx) => (
//                         <span key={idx}>
//                           {assignee.name}
//                           <br />
//                         </span>
//                       ))}
//                     </td>

//                     <td className="p-1">
//                       <select
//                         className="border p-1 rounded dark:bg-gray-900 dark:text-white"
//                         value={task.statusName}
//                         onChange={(e) =>
//                           handleStatusChange(task.taskId, e.target.value)
//                         }
//                       >
//                         {statuses
//                           .filter((status) => status.active === true)
//                           .map((status) => (
//                             <option
//                               key={status.id} // Use unique id if available
//                               value={status.name} // This value gets passed to onChange
//                             >
//                               {status.name}
//                             </option>
//                           ))}
//                       </select>
//                     </td>

//                     <td className="p-1 space-x-1 flex flex-wrap">
//                       {task.createdById === user?.id ||
//                       user?.accountType === "COMPANY" ? (
//                         <>
//                           <FaEdit
//                             title="Edit"
//                             className="cursor-pointer text-blue-500 hover:text-blue-700 dark:hover:text-blue-300"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               handleEditClick(task);
//                             }}
//                           />
//                           <FaTrash
//                             title="Delete"
//                             className="cursor-pointer text-red-500 hover:text-red-700 dark:hover:text-red-300"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               setTaskToDelete(task);
//                               setShowDeleteModal(true);
//                             }}
//                           />
//                         </>
//                       ) : null}

//                       {/* Common icons shown for all users */}
//                       <FaReply
//                         title="Respond"
//                         className="cursor-pointer text-blue-500 hover:text-blue-700 dark:hover:text-blue-300"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleResponseClick(task);
//                         }}
//                       />
//                       <FaTicketAlt
//                         title="View Ticket"
//                         className="cursor-pointer text-green-600 hover:text-green-800 dark:hover:text-green-300"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleViewTicket(task);
//                         }}
//                       />
//                       <FaCommentDots
//                         title="View Response"
//                         className="cursor-pointer text-indigo-500 hover:text-indigo-700 dark:hover:text-indigo-300"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleViewResponse(task.taskId);
//                         }}
//                       />

//                       {task.attachment && task.attachment !== "null" && (
//                         <>
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               setSelectedTask(task);
//                               handleViewAttachment(task);
//                             }}
//                             className="text-blue-500 hover:text-blue-700 dark:hover:text-blue-300"
//                             title="View Attachment"
//                           >
//                             <FaEye />
//                           </button>
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               handleDownloadAttachment(task);
//                             }}
//                             className="text-green-500 hover:text-green-700 dark:hover:text-green-300"
//                             title="Download Attachment"
//                           >
//                             <FaDownload />
//                           </button>
//                         </>
//                       )}
//                     </td>
//                   </tr>
//                   {expandedTask === task.taskId && (
//                     <tr>
//                       <td
//                         colSpan="9"
//                         className="p-2 bg-gray-50 dark:bg-gray-800 dark:bg-gray-800"
//                       >
//                         <strong>Description:</strong>
//                         <pre
//                           style={{
//                             whiteSpace: "pre-wrap",
//                             wordWrap: "break-word",
//                             maxWidth: "100%",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             overflowY: "auto",
//                             padding: "6px",
//                             margin: "0",
//                             // backgroundColor: '#f8f9fa',
//                             borderRadius: "4px",
//                           }}
//                         >
//                           {task.description}
//                         </pre>
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="text-center p-4">
//                   "No records found"
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 0 && (
//         <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4">
//           <div className="flex items-center gap-2 w-full sm:w-auto relative z-10">
//             <span className="text-sm text-gray-600 dark:text-gray-300 whitespace-nowrap">
//               Items per page:
//             </span>
//             <Select
//               className="w-20 sm:w-24 text-sm"
//               classNamePrefix="select"
//               menuPortalTarget={
//                 typeof window !== "undefined" ? document.body : null
//               }
//               menuPosition="fixed"
//               styles={{
//                 control: (baseStyles, state) => {
//                   const isDark =
//                     typeof window !== "undefined" &&
//                     document.documentElement.classList.contains("dark");
//                   return {
//                     ...baseStyles,
//                     backgroundColor: isDark ? "#374151" : "#ffffff",
//                     color: isDark ? "#ffffff" : "#000000",
//                     borderColor: isDark ? "#4b5563" : "#d1d5db",
//                     minHeight: "32px",
//                     fontSize: "0.875rem",
//                     zIndex: 10,
//                   };
//                 },
//                 singleValue: (base) => {
//                   const isDark =
//                     typeof window !== "undefined" &&
//                     document.documentElement.classList.contains("dark");
//                   return {
//                     ...base,
//                     color: isDark ? "#ffffff" : "#000000",
//                   };
//                 },
//                 menu: (base) => {
//                   const isDark =
//                     typeof window !== "undefined" &&
//                     document.documentElement.classList.contains("dark");
//                   return {
//                     ...base,
//                     backgroundColor: isDark ? "#1f2937" : "#ffffff",
//                     color: isDark ? "#ffffff" : "#000000",
//                     zIndex: 9999,
//                   };
//                 },
//                 menuPortal: (base) => ({
//                   ...base,
//                   zIndex: 9999,
//                 }),
//                 option: (base, state) => {
//                   const isDark =
//                     typeof window !== "undefined" &&
//                     document.documentElement.classList.contains("dark");
//                   return {
//                     ...base,
//                     backgroundColor: state.isFocused
//                       ? isDark
//                         ? "#4b5563"
//                         : "#e5e7eb"
//                       : isDark
//                         ? "#1f2937"
//                         : "#ffffff",
//                     color: isDark ? "#ffffff" : "#000000",
//                     cursor: "pointer",
//                   };
//                 },
//               }}
//               value={{ value: pageSize, label: pageSize.toString() }}
//               onChange={(selectedOption) => {
//                 setPageSize(Number(selectedOption.value));
//                 setPageNumber(0);
//                 fetchPage(0);
//               }}
//               options={[
//                 { value: 5, label: "5" },
//                 { value: 10, label: "10" },
//                 { value: 20, label: "20" },
//                 { value: 50, label: "50" },
//               ]}
//             />
//           </div>
//           <div className="flex flex-wrap justify-center items-center gap-1 sm:gap-2 w-full sm:w-auto">
//             <button
//               onClick={() => {
//                 setPageNumber(0);
//                 fetchPage(0);
//               }}
//               className="px-2 sm:px-4 py-1 bg-blue-100 hover:bg-blue-200 text-xs sm:text-sm text-blue-800 rounded disabled:opacity-50"
//               disabled={pageNumber === 0}
//             >
//               First
//             </button>
//             <button
//               onClick={() => {
//                 const newPage = Math.max(pageNumber - 1, 0);
//                 setPageNumber(newPage);
//                 fetchPage(newPage);
//               }}
//               className="px-2 sm:px-4 py-1 bg-blue-100 hover:bg-blue-200 text-xs sm:text-sm text-blue-800 rounded disabled:opacity-50"
//               disabled={pageNumber === 0}
//             >
//               Prev
//             </button>

//             <span className="text-xs sm:text-sm font-medium px-2">
//               Page {pageNumber + 1} of {totalPages}
//             </span>

//             <button
//               onClick={() => {
//                 const newPage = Math.min(pageNumber + 1, totalPages - 1);
//                 setPageNumber(newPage);
//                 fetchPage(newPage);
//               }}
//               className="px-2 sm:px-4 py-1 bg-blue-100 hover:bg-blue-200 text-xs sm:text-sm text-blue-800 rounded disabled:opacity-50"
//               disabled={pageNumber >= totalPages - 1}
//             >
//               Next
//             </button>
//             <button
//               onClick={() => {
//                 setPageNumber(totalPages - 1);
//                 fetchPage(totalPages - 1);
//               }}
//               className="px-2 sm:px-4 py-1 bg-blue-100 hover:bg-blue-200 text-xs sm:text-sm text-blue-800 rounded disabled:opacity-50"
//               disabled={pageNumber >= totalPages - 1}
//             >
//               Last
//             </button>
//           </div>
//         </div>
//       )}

//       {isModalOpen && selectedTask && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm p-2 sm:p-4">
//           <div className="bg-white dark:bg-gray-800 dark:text-white p-4 sm:p-6 rounded-xl w-full max-w-4xl mx-auto max-h-[90vh] overflow-y-auto shadow-xl border border-gray-200 dark:border-gray-700">
//             {/* Header */}
//             <div className="flex justify-between items-center border-b pb-3 mb-3">
//               <h2 className="text-xl sm:text-2xl dark:text-white font-semibold text-gray-800 flex items-center gap-2">
//                 🧾 Ticket Details
//               </h2>
//               <button
//                 onClick={handleCloseButton}
//                 className="text-gray-500 hover:text-red-500 dark:text-white text-xl transition duration-150"
//               >
//                 ✖
//               </button>
//             </div>

//             {/* Basic Info */}
//             <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-1 sm:gap-4 mb-4 text-sm sm:text-base text-gray-700">
//               <div>
//                 <span className="font-semibold dark:text-white text-gray-900">
//                   Assigned To:
//                 </span>
//                 <span className="dark:text-white mx-2">
//                   {selectedTask.assignedTo?.map((u) => u.name).join(", ") ||
//                     "_"}
//                 </span>
//               </div>
//               <div>
//                 <span className="font-semibold dark:text-white text-gray-900">
//                   Status:
//                 </span>
//                 <span className="mx-2">
//                   {selectedTask.statusUpdates?.[
//                     selectedTask.statusUpdates.length - 1
//                   ]?.newStatus === "PENDING_APPROVAL" &&
//                   selectedTask.createdById === user?.id ? (
//                     <div className="flex items-center flex-wrap gap-2 mt-1">
//                       <span className="inline-block px-2 py-1 rounded text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
//                         {selectedTask.statusUpdates?.[
//                           selectedTask.statusUpdates.length - 1
//                         ]?.newStatus || "Pending"}
//                       </span>
//                       <button
//                         className="text-green-600 hover:scale-110"
//                         title="Approve"
//                         onClick={() => {
//                           setActionType("APPROVED");
//                           setShowRemarkInput(true);
//                         }}
//                       >
//                         ✅
//                       </button>
//                       <button
//                         className="text-red-600 hover:scale-110"
//                         title="Reject"
//                         onClick={() => {
//                           setActionType("REJECTED");
//                           setShowRemarkInput(true);
//                         }}
//                       >
//                         ❌
//                       </button>
//                     </div>
//                   ) : (
//                     <span
//                       className="inline-block px-2 py-1 rounded text-xs font-medium"
//                       style={{
//                         backgroundColor: selectedTask.statusColor || "#e5e7eb",
//                       }}
//                     >
//                       {selectedTask.statusUpdates?.[
//                         selectedTask.statusUpdates.length - 1
//                       ]?.newStatus || selectedTask.statusName}
//                     </span>
//                   )}
//                 </span>

//                 {/* Remark Input */}
//                 {showRemarkInput && (
//                   <div className="mt-2 dark:bg-gray-700 dark:text-white">
//                     <textarea
//                       rows="3"
//                       value={remarkInput}
//                       onChange={(e) => setRemarkInput(e.target.value)}
//                       className="w-full border border-gray-300 rounded-md p-2 text-sm dark:bg-gray-700 dark:text-white"
//                       placeholder="Enter your remark..."
//                     />
//                     <div className="flex gap-2 mt-2">
//                       <button
//                         onClick={() =>
//                           handleApproveOrReject(
//                             selectedTask.taskId,
//                             actionType,
//                             remarkInput,
//                           )
//                         }
//                         className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-1.5 rounded-md"
//                       >
//                         Submit
//                       </button>
//                       <button
//                         onClick={() => {
//                           setRemarkInput("");
//                           setShowRemarkInput(false);
//                         }}
//                         className="bg-gray-300 hover:bg-gray-400 text-gray-800 text-sm px-4 py-1.5 rounded-md"
//                       >
//                         Cancel
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Status + Comments */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
//               {/* Status Updates */}
//               <div className="bg-gray-50 rounded-lg p-3 border dark:bg-gray-700 dark:text-white">
//                 <div className="flex justify-between items-center mb-2">
//                   <h3 className="text-base sm:text-lg font-semibold text-gray-800 dark:text-white">
//                     📌 Status Updates
//                   </h3>
//                 </div>
//                 <div className="max-h-[180px] overflow-y-auto pr-1.5 text-sm space-y-2">
//                   {selectedTask.statusUpdates?.length > 0 ? (
//                     <ul className="list-disc pl-4">
//                       {selectedTask.statusUpdates.map((update, idx) => (
//                         <li key={idx} className="mb-2">
//                           <div className="flex flex-wrap gap-1">
//                             <span className="font-medium">
//                               {update.updatedByName}
//                             </span>
//                             <span>changed status from</span>
//                             <span className="font-medium">
//                               {update.oldStatus}
//                             </span>
//                             <span>to</span>
//                             <span className="font-medium">
//                               {update.newStatus}
//                             </span>
//                           </div>
//                           <div className="text-gray-500 text-xs dark:text-white">
//                             {new Date(update.updatedAt).toLocaleString()}
//                           </div>
//                           {update.remark && (
//                             <div className="text-gray-500 text-xs italic mt-1 dark:text-white">
//                               Remark: {update.remark}
//                             </div>
//                           )}
//                         </li>
//                       ))}
//                     </ul>
//                   ) : (
//                     <p className="text-gray-400 dark:text-white">
//                       No status updates found.
//                     </p>
//                   )}
//                 </div>
//               </div>

//               {/* Comments */}
//               <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 shadow-sm dark:bg-gray-800 dark:border-gray-700">
//                 {/* Header with comment count */}
//                 <div className="flex justify-between items-center mb-3">
//                   <div className="flex items-center space-x-2">
//                     <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
//                       Comments
//                     </h3>
//                     <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">
//                       {comments.length}
//                     </span>
//                   </div>
//                   <button
//                     onClick={() => setIsCommentBoxOpen(true)}
//                     className="flex items-center space-x-1 text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
//                   >
//                     <FaPlusCircle className="text-lg" />
//                     <span className="text-sm font-medium">Add Comment</span>
//                   </button>
//                 </div>

//                 {/* Comments list */}
//                 <div className="space-y-4 max-h-64 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent dark:scrollbar-thumb-gray-600">
//                   {comments.length > 0 ? (
//                     comments.map((comment, idx) => (
//                       <div
//                         key={comment.commentId || idx}
//                         className="group relative p-3 bg-white rounded-lg border border-gray-200 hover:shadow-sm transition-shadow dark:bg-gray-700 dark:border-gray-600"
//                       >
//                         {/* Comment content */}
//                         {editingCommentId === (comment.commentId || idx) ? (
//                           <div className="space-y-2">
//                             <textarea
//                               value={editedComment}
//                               onChange={(e) => {
//                                 if (e.target.value.length <= 150) {
//                                   setEditedComment(e.target.value);
//                                 }
//                               }}
//                               className="w-full p-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:text-white"
//                               rows={3}
//                               maxLength={150}
//                               autoFocus
//                             />
//                             <div className="flex justify-between items-center">
//                               <span className="text-xs text-gray-500 dark:text-gray-400">
//                                 {editedComment.length}/150 characters
//                               </span>
//                               {editedComment.length > 150 && (
//                                 <span className="text-xs text-red-500">
//                                   Comment must not exceed 150 characters
//                                 </span>
//                               )}
//                             </div>
//                             <div className="flex space-x-2">
//                               <button
//                                 onClick={() => {
//                                   if (editedComment.length > 150) return;
//                                   handleUpdateComment(
//                                     ticketDetails.ticketId,
//                                     comment.commentId || idx,
//                                     editedComment,
//                                   );
//                                 }}
//                                 disabled={editedComment.length > 150}
//                                 className={`px-3 py-1.5 text-xs font-medium rounded-md ${
//                                   editedComment.length > 150
//                                     ? "bg-gray-200 text-gray-500 cursor-not-allowed dark:bg-gray-600 dark:text-gray-400"
//                                     : "bg-blue-600 text-white hover:bg-blue-700"
//                                 }`}
//                               >
//                                 Update
//                               </button>
//                               <button
//                                 onClick={() => {
//                                   setEditingCommentId(null);
//                                   setEditedComment("");
//                                 }}
//                                 className="px-3 py-1.5 text-xs font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md dark:bg-gray-600 dark:text-gray-300 dark:hover:bg-gray-500"
//                               >
//                                 Cancel
//                               </button>
//                             </div>
//                           </div>
//                         ) : (
//                           <>
//                             <p className="text-sm text-gray-700 dark:text-gray-300 break-words overflow-hidden">
//                               {comment.content}
//                             </p>
//                             <div className="mt-2 flex items-center justify-between">
//                               <div className="flex items-center space-x-2">
//                                 <span className="text-xs text-gray-500 dark:text-gray-400">
//                                   {comment.userName}
//                                 </span>
//                                 <span className="text-xs text-gray-400 dark:text-gray-500">
//                                   •
//                                 </span>
//                                 <span className="text-xs text-gray-500 dark:text-gray-400">
//                                   {new Date(comment.createdAt).toLocaleString(
//                                     "en-US",
//                                     {
//                                       month: "short",
//                                       day: "numeric",
//                                       hour: "2-digit",
//                                       minute: "2-digit",
//                                     },
//                                   )}
//                                 </span>
//                               </div>
//                               {comment.userId === user?.id && (
//                                 <div className="flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
//                                   <button
//                                     onClick={() => {
//                                       setEditingCommentId(
//                                         comment.commentId || idx,
//                                       );
//                                       setEditedComment(comment.content);
//                                     }}
//                                     className="text-blue-500 hover:text-blue-700 p-1 rounded-full hover:bg-blue-50 dark:hover:bg-gray-600"
//                                     title="Edit"
//                                   >
//                                     <svg
//                                       xmlns="http://www.w3.org/2000/svg"
//                                       className="h-4 w-4"
//                                       fill="none"
//                                       viewBox="0 0 24 24"
//                                       stroke="currentColor"
//                                     >
//                                       <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth={2}
//                                         d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                                       />
//                                     </svg>
//                                   </button>
//                                   <button
//                                     onClick={() =>
//                                       handleDeleteComment(
//                                         comment.commentId || idx,
//                                       )
//                                     }
//                                     className="text-red-500 hover:text-red-700 p-1 rounded-full hover:bg-red-50 dark:hover:bg-gray-600"
//                                     title="Delete"
//                                   >
//                                     <svg
//                                       xmlns="http://www.w3.org/2000/svg"
//                                       className="h-4 w-4"
//                                       fill="none"
//                                       viewBox="0 0 24 24"
//                                       stroke="currentColor"
//                                     >
//                                       <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth={2}
//                                         d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                                       />
//                                     </svg>
//                                   </button>
//                                 </div>
//                               )}
//                             </div>
//                           </>
//                         )}
//                       </div>
//                     ))
//                   ) : (
//                     <div className="text-center py-6">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="h-12 w-12 mx-auto text-gray-400 dark:text-gray-500"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={1}
//                           d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
//                         />
//                       </svg>
//                       <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
//                         No comments yet. Be the first to comment!
//                       </p>
//                     </div>
//                   )}
//                 </div>

//                 {/* Comment Input */}
//                 {isCommentBoxOpen && (
//                   <div className="mt-3 dark:bg-gray-700 dark:text-white">
//                     <textarea
//                       rows="3"
//                       value={newComment}
//                       onChange={(e) => {
//                         if (e.target.value.length <= 150) {
//                           setNewComment(e.target.value);
//                           setCommentLengthError("");
//                         } else {
//                           setCommentLengthError(
//                             "comment must not exceed 150 characters",
//                           );
//                         }
//                       }}
//                       className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm dark:bg-gray-700"
//                       placeholder="Write your comment..."
//                     />
//                     <div className="flex justify-between items-center mt-1">
//                       <span className="text-xs text-gray-500 dark:text-gray-300">
//                         {newComment.length}/150 characters
//                       </span>
//                       {commentLengthError && (
//                         <span className="text-xs text-red-500">
//                           {commentLengthError}
//                         </span>
//                       )}
//                     </div>
//                     <button
//                       onClick={handleAddComment}
//                       disabled={newComment.length > 150}
//                       className={`mt-2 bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-1.5 rounded-md transition ${
//                         newComment.length > 150
//                           ? "opacity-50 cursor-not-allowed"
//                           : ""
//                       }`}
//                     >
//                       Submit
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {editModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-2 sm:p-4 ">
//           <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl h-[95vh] flex flex-col">
//             {/* Header */}
//             <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10 dark:bg-gray-700 dark:text-white">
//               <h2 className="text-lg sm:text-xl font-bold text-gray-800 dark:text-white">
//                 Edit Task
//               </h2>
//               <button
//                 onClick={() => setEditModalOpen(false)}
//                 className="p-2 rounded-full hover:bg-gray-100 focus:outline-none"
//                 aria-label="Close modal"
//               >
//                 <XMarkIcon className="h-6 w-6 text-gray-500 hover:text-gray-700 transition" />
//               </button>
//             </div>

//             {/* Form Body (scrollable if needed) */}
//             <div className="overflow-y-auto px-4 py-2 sm:p-4 flex-grow dark:bg-gray-700 dark:text-white">
//               <form
//                 id="editTaskForm"
//                 onSubmit={handleUpdateSubmit}
//                 className="space-y-3"
//               >
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-3 dark:bg-gray-700 dark:text-white">
//                   {/* Subject */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-white">
//                       Subject
//                     </label>
//                     <input
//                       type="text"
//                       name="subject"
//                       value={editedTask.subject || ""}
//                       onChange={handleInputChange}
//                       className="w-full p-2 border border-gray-300 rounded-md dark:text-white dark:bg-gray-700"
//                       required
//                     />
//                   </div>

//                   {/* Priority */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-white">
//                       Priority
//                     </label>
//                     <select
//                       name="priority"
//                       value={editedTask.priority || "Low"}
//                       onChange={handleInputChange}
//                       className="w-full p-2 border border-gray-300 rounded-md dark:text-white dark:bg-gray-700"
//                     >
//                       <option value="Low">Low</option>
//                       <option value="Medium">Medium</option>
//                       <option value="High">High</option>
//                     </select>
//                   </div>

//                   {/* Label */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-white">
//                       Label (Optional)
//                     </label>
//                     <select
//                       name="labelName"
//                       value={editedTask.labelName || ""}
//                       onChange={handleLabelChange}
//                       className="w-full p-2 border border-gray-300 rounded-md dark:text-white dark:bg-gray-700"
//                     >
//                       <option value="">Select Label</option>
//                       {labels.map((label) => (
//                         <option key={label.id} value={label.name}>
//                           {label.name}
//                         </option>
//                       ))}
//                     </select>
//                     {editedTask.labelColor && (
//                       <div
//                         className="w-6 h-3 mt-1 rounded"
//                         style={{ backgroundColor: editedTask.labelColor }}
//                       ></div>
//                     )}
//                   </div>

//                   {/* End Date */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-white">
//                       End Date
//                     </label>
//                     <input
//                       type="date"
//                       name="endDate"
//                       value={editedTask.endDate || ""}
//                       onChange={handleInputChange}
//                       className="w-full p-2 border border-gray-300 rounded-md dark:text-white dark:bg-gray-700"
//                     />
//                   </div>

//                   {/* File Upload */}
//                   <div className="md:col-span-2">
//                     <label className="block text-sm font-medium text-gray-700 dark:text-white">
//                       Update File (Optional)
//                     </label>
//                     <input
//                       type="file"
//                       name="file"
//                       onChange={(e) =>
//                         setEditedTask({
//                           ...editedTask,
//                           file: e.target.files[0],
//                         })
//                       }
//                       className="w-full p-2 text-sm border border-gray-300 rounded-md file:mr-2 file:py-1 file:px-3 file:rounded file:border-0 file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 dark:text-white dark:bg-gray-700"
//                     />
//                   </div>
//                 </div>

//                 {/* Assign To */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-white">
//                     Assign To
//                   </label>
//                   <Select
//                     isMulti
//                     name="assignedToJson"
//                     options={users.map((user) => ({
//                       value: user.id,
//                       label: `${user.fname} ${user.lname}`,
//                     }))}
//                     value={
//                       editedTask.assignedToJson
//                         ? JSON.parse(editedTask.assignedToJson).map((user) => ({
//                             value: user.id,
//                             label: user.name,
//                           }))
//                         : []
//                     }
//                     onChange={handleAssignedUsersChange}
//                     className="basic-multi-select"
//                     classNamePrefix="select"
//                     styles={{
//                       control: (base, state) => ({
//                         ...base,
//                         minHeight: "42px",
//                         padding: "2px 4px",
//                         borderRadius: "0.375rem", // Tailwind rounded-md
//                         borderColor: "#d1d5db", // Tailwind gray-300
//                         backgroundColor:
//                           document.documentElement.classList.contains("dark")
//                             ? "#374151" // Tailwind gray-700
//                             : "white",
//                         color: document.documentElement.classList.contains(
//                           "dark",
//                         )
//                           ? "white"
//                           : "black",
//                         boxShadow: state.isFocused
//                           ? "0 0 0 1px #60a5fa"
//                           : "none", // Tailwind blue-400
//                         "&:hover": {
//                           borderColor: "#9ca3af", // Tailwind gray-400
//                         },
//                       }),
//                       menu: (base) => ({
//                         ...base,
//                         borderRadius: "0.375rem",
//                         marginTop: 4,
//                         backgroundColor:
//                           document.documentElement.classList.contains("dark")
//                             ? "#1f2937" // Tailwind gray-800
//                             : "white",
//                         color: document.documentElement.classList.contains(
//                           "dark",
//                         )
//                           ? "white"
//                           : "black",
//                       }),
//                       option: (base, { isFocused, isSelected }) => ({
//                         ...base,
//                         backgroundColor: isFocused
//                           ? document.documentElement.classList.contains("dark")
//                             ? "#4b5563" // Tailwind gray-600
//                             : "#f3f4f6" // Tailwind gray-100
//                           : isSelected
//                             ? "#60a5fa" // Tailwind blue-400
//                             : "transparent",
//                         color: document.documentElement.classList.contains(
//                           "dark",
//                         )
//                           ? "white"
//                           : "black",
//                         cursor: "pointer",
//                       }),
//                       multiValue: (base) => ({
//                         ...base,
//                         backgroundColor:
//                           document.documentElement.classList.contains("dark")
//                             ? "#6b7280" // Tailwind gray-500
//                             : "#e5e7eb", // Tailwind gray-200
//                         borderRadius: "0.375rem",
//                         padding: "2px 6px",
//                       }),
//                       multiValueLabel: (base) => ({
//                         ...base,
//                         color: document.documentElement.classList.contains(
//                           "dark",
//                         )
//                           ? "white"
//                           : "black",
//                       }),
//                       multiValueRemove: (base) => ({
//                         ...base,
//                         color: "#ef4444", // Tailwind red-500
//                         ":hover": {
//                           backgroundColor: "#f87171", // red-400
//                           color: "white",
//                         },
//                       }),
//                     }}
//                   />
//                 </div>

//                 <div className="w-full">
//                   <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//                     Participant Email
//                   </label>
//                   <div className="flex gap-2">
//                     <input
//                       type="email"
//                       value={participantEmail}
//                       onChange={(e) => setParticipantEmail(e.target.value)}
//                       className="w-full p-2 border border-gray-300 rounded-md dark:bg-gray-700"
//                       placeholder="Add participant email"
//                     />
//                     <button
//                       type="button"
//                       onClick={handleAddParticipant}
//                       className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//                     >
//                       Add
//                     </button>
//                   </div>
//                 </div>

//                 {/* List of Added Participants */}
//                 {participants.length > 0 && (
//                   <div className="mt-2 space-y-1">
//                     {participants.map((participant, index) => {
//                       const email = Array.isArray(participant)
//                         ? participant[1] || participant[0]
//                         : participant;
//                       return (
//                         <div
//                           key={index}
//                           className="flex items-center justify-between bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-md"
//                         >
//                           <span className="text-sm text-gray-800 dark:text-white">
//                             {email}
//                           </span>
//                           <button
//                             type="button"
//                             onClick={() => {
//                               setParticipants((prev) =>
//                                 prev.filter((_, i) => i !== index),
//                               );
//                             }}
//                             className="text-red-500 hover:text-red-700 text-sm"
//                             title="Remove"
//                           >
//                             ❌
//                           </button>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 )}

//                 {/* Description */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-white">
//                     Description
//                   </label>
//                   <textarea
//                     name="description"
//                     value={editedTask.description || ""}
//                     onChange={handleInputChange}
//                     required
//                     className="w-full p-2 border border-gray-300 rounded-md min-h-[80px] dark:text-white dark:bg-gray-700"
//                   />
//                 </div>
//               </form>
//             </div>

//             {/* Footer Buttons */}
//             <div className="flex justify-end gap-3 border-t px-4 py-3 dark:text-white dark:bg-gray-700">
//               <button
//                 type="button"
//                 onClick={() => setEditModalOpen(false)}
//                 className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 form="editTaskForm"
//                 // onClick={handleUpdateSubmit}
//                 className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
//               >
//                 Update Task
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showNotifyModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md text-center dark:bg-gray-900 dark:text-white">
//             <div className="flex justify-end">
//               <button
//                 type="button"
//                 onClick={() => {
//                   setShowNotifyModal?.(false);
//                 }}
//                 className="text-gray-600 hover:text-red-600 text-xl font-bold"
//                 aria-label="Close"
//               >
//                 &times;
//               </button>
//             </div>
//             <h2 className="text-lg font-semibold mb-4">
//               Notification Preference
//             </h2>
//             <p className="mb-4">
//               How would you like to notify{" "}
//               <span className="font-bold">{pendingParticipant.email}</span>?
//             </p>
//             <div className="flex justify-around gap-4">
//               <button
//                 onClick={() => confirmParticipant("both")}
//                 className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
//               >
//                 Notification + Email
//               </button>
//               <button
//                 onClick={() => confirmParticipant("email")}
//                 className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
//               >
//                 Email Only
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {isResponseModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm ">
//           <div className="bg-white p-6 rounded-lg w-96 shadow-xl relative dark:bg-gray-700 dark:text-white">
//             <h2 className="text-xl font-semibold mb-4">Add Response</h2>
//             <textarea
//               name="content"
//               value={responseData.content}
//               onChange={handleInputChange}
//               placeholder="Type your response..."
//               className="w-full border p-2 rounded mb-4 dark:bg-gray-700 dark:text-white"
//             />
//             <input type="file" onChange={handleFileChange} className="mb-4" />
//             <div className="flex justify-end gap-2">
//               <button
//                 onClick={() => setIsResponseModalOpen(false)}
//                 className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleResponseSubmit}
//                 className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {isViewModalOpen && selectedTask && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex justify-center items-center z-50">
//           <div className="bg-white rounded-2xl w-full max-w-3xl p-6 shadow-2xl relative dark:bg-gray-700 dark:text-white">
//             <h2 className="text-xl font-bold text-indigo-600 mb-6 border-b pb-2">
//               {selectedTask.subject}
//             </h2>

//             <div className="space-y-5 max-h-[70vh] custom-scroll pr-2">
//               {taskResponses.length === 0 ? (
//                 <p className="text-gray-500 italic">No responses available.</p>
//               ) : (
//                 taskResponses.map((res, idx) => (
//                   <div
//                     key={idx}
//                     className="bg-gray-50 border border-gray-200 rounded-lg p-2 shadow-sm dark:bg-gray-700 dark:text-white"
//                   >
//                     <div className="flex justify-between dark:bg-gray-700 dark:text-white">
//                       <div>
//                         <p className="text-sm font-semibold text-gray-700 darK:text-white">
//                           {res.userName}
//                         </p>
//                         <p className="text-sm text-gray-800 mt-1 dark:text-white">
//                           {res.content}
//                         </p>
//                         <p className="text-xs text-gray-500 mt-1 dark:text-white">
//                           Posted on: {new Date(res.createdAt).toLocaleString()}
//                         </p>
//                       </div>

//                       <div className="flex gap-3 items-center text-lg ">
//                         <button
//                           onClick={() => toggleCommentBox(res.id)}
//                           title="Add Comment"
//                           className="text-gray-500 hover:text-indigo-500"
//                         >
//                           <FaCommentAlt />
//                         </button>

//                         {res.userId === user?.id && (
//                           <>
//                             <button
//                               title="Edit Response"
//                               onClick={() => handleEditResponse(res)}
//                               className="text-blue-500 hover:text-blue-700"
//                             >
//                               <FaEdit />
//                             </button>
//                             <button
//                               title="Delete Response"
//                               onClick={() => handleDeleteResponse(res.id)}
//                               className="text-red-500 hover:text-red-700"
//                             >
//                               <FaTrash />
//                             </button>
//                           </>
//                         )}

//                         {res.attachment && (
//                           <>
//                             <button
//                               title="View Attachment"
//                               onClick={() => handleViewFile(res)}
//                               className="text-green-600 hover:text-green-800"
//                             >
//                               <FaEye />
//                             </button>
//                             <button
//                               title="Download Attachment"
//                               onClick={() => handleDownloadFile(res)}
//                               className="text-gray-600 hover:text-gray-800"
//                             >
//                               <FaDownload />
//                             </button>
//                           </>
//                         )}
//                       </div>
//                     </div>

//                     {/* Comments */}
//                     <div className="mt-4 space-y-3">
//                       {res.comments?.map((comment) => (
//                         <div
//                           key={comment.commentId}
//                           className="bg-white dark:bg-gray-800 dark:text-white border-l-4 border-indigo-500 p-3 rounded-md shadow-sm max-w-full"
//                         >
//                           <p className="text-sm break-words whitespace-pre-wrap">
//                             <span className="font-semibold">
//                               {comment.userName || "Unknown"}:
//                             </span>{" "}
//                             {comment.content || "No comment text"}
//                           </p>
//                           <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
//                             {new Date(comment.createdAt).toLocaleString()}
//                           </p>

//                           {comment.userId === user?.id && (
//                             <div className="flex gap-3 mt-2 flex-wrap">
//                               <button
//                                 onClick={() =>
//                                   handleEditComment(res.id, comment)
//                                 }
//                                 className="text-blue-600 hover:text-blue-800 text-sm flex items-center gap-1"
//                                 title="Edit Comment"
//                               >
//                                 <FaEdit /> <span>Edit</span>
//                               </button>
//                               <button
//                                 onClick={() =>
//                                   handleDeleteResponseComment(
//                                     res.id,
//                                     comment.commentId,
//                                   )
//                                 }
//                                 className="text-red-600 hover:text-red-800 text-sm flex items-center gap-1"
//                                 title="Delete Comment"
//                               >
//                                 <FaTrash /> <span>Delete</span>
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       ))}
//                     </div>

//                     {/* Comment Input */}
//                     {showCommentBoxId === res.id && (
//                       <div className="mt-3 dark:bg-gray-700 dark:text-white">
//                         <textarea
//                           rows={2}
//                           className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm dark:bg-gray-700 dark:text-white"
//                           value={commentInput}
//                           onChange={(e) => {
//                             if (e.target.value.length <= 150) {
//                               setCommentInput(e.target.value);
//                             }
//                           }}
//                           placeholder="Write your comment..."
//                           maxLength={150}
//                         ></textarea>
//                         <div className="flex justify-between items-center mt-1">
//                           <span className="text-xs text-gray-500 dark:text-gray-300">
//                             {commentInput.length}/150 characters
//                           </span>
//                           {commentInput.length > 150 && (
//                             <span className="text-xs text-red-500">
//                               comment must not exceed 150 characters
//                             </span>
//                           )}
//                         </div>
//                         <div className="flex justify-end mt-2 gap-2">
//                           <button
//                             onClick={() => toggleCommentBox(res.id)}
//                             className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 dark:text-white"
//                           >
//                             Cancel
//                           </button>
//                           <button
//                             onClick={() => submitComment(res.id)}
//                             disabled={commentInput.length > 150}
//                             className={`px-4 py-1 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 text-sm ${
//                               commentInput.length > 150
//                                 ? "opacity-50 cursor-not-allowed"
//                                 : ""
//                             }`}
//                           >
//                             {editingComment ? "Update" : "Comment"}
//                           </button>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ))
//               )}
//             </div>

//             <button
//               onClick={() => {
//                 setIsViewModalOpen(false);
//                 setShowCommentBoxId(null);
//                 setCommentInput("");
//                 setEditingComment(null);
//               }}
//               className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl"
//             >
//               ✕
//             </button>
//           </div>
//         </div>
//       )}

//       {responseFileModalOpen && currentResponseFile && (
//         <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
//           <div className="relative bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
//             <div className="flex justify-between items-center p-4 border-b dark:bg-gray-700 dark:text-white">
//               <h3 className="text-lg font-medium">
//                 {currentResponseFile.name}
//               </h3>
//               <button
//                 onClick={() => {
//                   setResponseFileModalOpen(false);
//                   URL.revokeObjectURL(currentResponseFile.url);
//                   setCurrentResponseFile(null);
//                 }}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <FaTimes className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="flex-1 overflow-auto p-4 flex items-center justify-center">
//               {currentResponseFile.type === "image" ? (
//                 <img
//                   src={currentResponseFile.url}
//                   alt="File preview"
//                   className="max-w-full max-h-[70vh] object-contain"
//                 />
//               ) : currentResponseFile.type === "pdf" ? (
//                 <iframe
//                   src={`${currentResponseFile.url}#toolbar=0`}
//                   className="w-full h-[70vh] border-none"
//                   title="PDF preview"
//                 />
//               ) : currentResponseFile.type === "video" ? (
//                 <video controls className="w-full max-h-[70vh]">
//                   <source
//                     src={currentResponseFile.url}
//                     type={`video/${currentResponseFile.name.split(".").pop()}`}
//                   />
//                   Your browser does not support the video tag.
//                 </video>
//               ) : currentResponseFile.type === "audio" ? (
//                 <audio controls className="w-full">
//                   <source
//                     src={currentResponseFile.url}
//                     type={`audio/${currentResponseFile.name.split(".").pop()}`}
//                   />
//                   Your browser does not support the audio element.
//                 </audio>
//               ) : currentResponseFile.type === "office" ? (
//                 <iframe
//                   src={getOfficeViewerUrl(currentResponseFile.url)}
//                   className="w-full h-[70vh] border-none"
//                   title="Office document preview"
//                   allowFullScreen
//                 />
//               ) : currentResponseFile.type === "text" ? (
//                 <iframe
//                   src={currentResponseFile.url}
//                   className="w-full h-[70vh] border-none"
//                   title="Text preview"
//                 />
//               ) : (
//                 <div className="text-center p-4">
//                   <p className="text-gray-500 mb-4">
//                     Preview not available for this file type
//                   </p>
//                   <button
//                     onClick={() =>
//                       handleDownloadFile({
//                         id: taskResponses.find(
//                           (r) => r.attachment === currentResponseFile.name,
//                         )?.id,
//                         attachment: currentResponseFile.name,
//                       })
//                     }
//                     className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                   >
//                     Download File
//                   </button>
//                 </div>
//               )}
//             </div>

//             <div className="flex justify-end p-4 border-t">
//               <button
//                 onClick={() =>
//                   handleDownloadFile({
//                     id: taskResponses.find(
//                       (r) => r.attachment === currentResponseFile.name,
//                     )?.id,
//                     attachment: currentResponseFile.name,
//                   })
//                 }
//                 className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//               >
//                 Download
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showDeleteModal && taskToDelete && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//           <div className="bg-white rounded-lg p-6 shadow-md w-full max-w-sm dark:bg-gray-700 dark:text-white">
//             <h2 className="text-lg font-semibold text-gray-800 mb-4 dark:text-white">
//               Confirm Delete
//             </h2>
//             <p className="text-gray-600 mb-6 dark:text-white">
//               Are you sure you want to delete this task?
//             </p>
//             <div className="flex justify-end space-x-4">
//               <button
//                 className="px-4 py-2 text-gray-700 border border-gray-300 rounded hover:bg-gray-100 dark:text-white dark:hover:bg-gray-500"
//                 onClick={() => setShowDeleteModal(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
//                 onClick={() => handleDeleteTask(taskToDelete.taskId)}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showAttachmentModal && (
//         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4">
//           <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-xl p-4 sm:p-6 w-full max-w-full sm:max-w-4xl h-[90vh] flex flex-col dark:bg-gray-700 dark:text-white">
//             <div className="flex justify-between items-center mb-4 dark:bg-gray-700 dark:text-white">
//               <h3 className="text-lg font-medium text-gray-900 dark:text-white truncate max-w-[80%]">
//                 {attachmentFilename}
//               </h3>
//               <button
//                 onClick={() => {
//                   setShowAttachmentModal(false);
//                   if (currentAttachment) {
//                     URL.revokeObjectURL(currentAttachment);
//                   }
//                 }}
//                 className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 p-1"
//               >
//                 <FaTimes className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="flex-1 flex flex-col items-center overflow-hidden dark:bg-gray-700 dark:text-white">
//               {attachmentType === "image" ? (
//                 <img
//                   src={currentAttachment}
//                   alt="Attachment preview"
//                   className="max-h-full max-w-full object-contain"
//                 />
//               ) : attachmentType === "video" ? (
//                 <video controls className="w-full h-full max-h-[70vh]">
//                   <source
//                     src={currentAttachment}
//                     type={`video/${attachmentFilename.split(".").pop()}`}
//                   />
//                   Your browser does not support the video tag.
//                 </video>
//               ) : attachmentType === "audio" ? (
//                 <audio controls className="w-full max-w-md">
//                   <source
//                     src={currentAttachment}
//                     type={`audio/${attachmentFilename.split(".").pop()}`}
//                   />
//                   Your browser does not support the audio element.
//                 </audio>
//               ) : attachmentType === "pdf" ? (
//                 <iframe
//                   src={`${currentAttachment}#toolbar=0`}
//                   className="w-full h-full min-h-[50vh] border-none"
//                   title="PDF preview"
//                 />
//               ) : ["word", "excel", "powerpoint"].includes(attachmentType) ? (
//                 <iframe
//                   src={getOfficeViewerUrl(currentAttachment)}
//                   className="w-full h-full min-h-[50vh] border-none"
//                   title={`${attachmentType} document preview`}
//                   allowFullScreen
//                 />
//               ) : attachmentType === "text" ? (
//                 <iframe
//                   src={currentAttachment}
//                   className="w-full h-full min-h-[50vh] border-none"
//                   title="Text preview"
//                 />
//               ) : (
//                 <div className="flex flex-col items-center justify-center h-full p-4 dark:bg-gray-700 dark:text-white">
//                   <p className="text-gray-500 mb-4 text-center">
//                     Preview not available for this file type
//                   </p>
//                   <button
//                     onClick={() => handleDownloadAttachment(selectedTask)}
//                     className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                   >
//                     Download File
//                   </button>
//                 </div>
//               )}
//             </div>

//             <div className="mt-4 flex justify-end dark:bg-gray-700 dark:text-white">
//               <button
//                 onClick={() => handleDownloadAttachment(selectedTask)}
//                 className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//               >
//                 Download
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {statusUpdateModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-96 dark:bg-gray-700 dark:text-white">
//             <h2 className="text-xl font-bold mb-4 dark:text-white">
//               Update Task Status
//             </h2>

//             <div className="mb-4">
//               <label className="block text-gray-700 mb-2 dark:text-white">
//                 New Status:
//               </label>
//               <div className="p-2 bg-gray-100 rounded border dark:bg-gray-700 dark:text-white">
//                 {selectedStatusUpdate.newStatus}
//               </div>
//             </div>

//             <div className="mb-4">
//               <label className="block text-gray-700 mb-2 dark:text-white">
//                 Remark:
//               </label>
//               <textarea
//                 className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
//                 rows="4"
//                 placeholder="Enter remark for status change..."
//                 value={selectedStatusUpdate.remark}
//                 onChange={(e) =>
//                   setSelectedStatusUpdate((prev) => ({
//                     ...prev,
//                     remark: e.target.value,
//                   }))
//                 }
//               />
//             </div>

//             <div className="flex justify-end space-x-2">
//               <button
//                 className="px-4 py-2 bg-gray-300 rounded"
//                 onClick={() => setStatusUpdateModalOpen(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//                 onClick={handleStatusUpdateSubmit}
//               >
//                 Update Status
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {editModalData && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex justify-center items-center z-50">
//           <div className="bg-white rounded-xl w-full max-w-xl p-6 shadow-xl relative dark:bg-gray-700 dark:text-white">
//             <h2 className="text-xl font-semibold text-indigo-600 mb-4 dark:text-dark">
//               Edit Response
//             </h2>

//             <label className="block mb-2 text-gray-700 font-medium dark:text-white">
//               Content
//               <textarea
//                 value={updatedContent}
//                 onChange={(e) => setUpdatedContent(e.target.value)}
//                 rows={4}
//                 className="w-full p-2 mt-1 border rounded dark:bg-gray-700 dark:text-white"
//               />
//             </label>

//             <label className="block mb-4 text-gray-700 font-medium dark:text-white">
//               Upload New File (optional)
//               <input
//                 type="file"
//                 onChange={(e) => setUpdatedFile(e.target.files[0])}
//                 className="w-full mt-1 border dark:bg-gray-700 dark:text-white"
//               />
//             </label>

//             <div className="flex justify-end gap-3">
//               <button
//                 className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
//                 onClick={() => setEditModalData(null)}
//               >
//                 Cancel
//               </button>

//               <button
//                 className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
//                 onClick={handleUpdateResponse}
//               >
//                 Update
//               </button>
//             </div>

//             <button
//               onClick={() => setEditModalData(null)}
//               className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
//             >
//               ✖
//             </button>
//           </div>
//         </div>
//       )}
//       {taskDetailsModalOpen && selectedTask && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm p-4">
//           <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
//             <div className="p-4 border-b dark:border-gray-700 flex justify-between items-center">
//               <h2 className="text-xl font-bold text-gray-800 dark:text-white">
//                 Task Details
//               </h2>
//               <button
//                 onClick={() => setTaskDetailsModalOpen(false)}
//                 className="text-gray-500 hover:text-gray-700 dark:text-white"
//               >
//                 <XMarkIcon className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//               {/* Basic Info */}
//               <div className="space-y-2">
//                 <h3 className="text-lg font-semibold text-gray-800 dark:text-white border-b pb-2">
//                   Basic Information
//                 </h3>
//                 <div>
//                   <span className="font-medium text-gray-700 dark:text-gray-300">
//                     Subject:
//                   </span>
//                   <span className="ml-2 dark:text-white">
//                     {selectedTask.subject}
//                   </span>
//                 </div>
//                 <div>
//                   <span className="font-medium text-gray-700 dark:text-gray-300">
//                     Priority:
//                   </span>
//                   <span className="ml-2 dark:text-white">
//                     {selectedTask.priority}
//                   </span>
//                 </div>
//                 <div>
//                   <span className="font-medium text-gray-700 dark:text-gray-300">
//                     Status:
//                   </span>
//                   <span className="ml-2 dark:text-white">
//                     {selectedTask.statusName}
//                   </span>
//                 </div>
//                 <div>
//                   <span className="font-medium text-gray-700 dark:text-gray-300">
//                     Start Date:
//                   </span>
//                   <span className="ml-2 dark:text-white">
//                     {/* {selectedTask.startDate} */}

//                     {formatDate(selectedTask.startDate)}
//                   </span>
//                 </div>
//                 <div>
//                   <span className="font-medium text-gray-700 dark:text-gray-300">
//                     End Date:
//                   </span>
//                   <span className="ml-2 dark:text-white">
//                     {/* {selectedTask.endDate} */}
//                     {formatDate(selectedTask.endDate)}
//                   </span>
//                 </div>
//               </div>

//               {/* Assignment Info */}
//               <div className="space-y-2">
//                 <h3 className="text-lg font-semibold text-gray-800 dark:text-white border-b pb-2">
//                   Assignment
//                 </h3>
//                 <div>
//                   <span className="font-medium text-gray-700 dark:text-gray-300">
//                     Created By:
//                   </span>
//                   <span className="ml-2 dark:text-white">
//                     {selectedTask.createdByName}
//                   </span>
//                 </div>
//                 <div>
//                   <span className="font-medium text-gray-700 dark:text-gray-300">
//                     Assigned To:
//                   </span>
//                   <div className="ml-2 dark:text-white">
//                     {selectedTask.assignedTo?.map((assignee, idx) => (
//                       <span key={idx}>
//                         {assignee.name}
//                         {idx < selectedTask.assignedTo.length - 1 ? ", " : ""}
//                       </span>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Description */}
//               <div className="md:col-span-2">
//                 <h3 className="text-lg font-semibold text-gray-800 dark:text-white border-b pb-2">
//                   Description
//                 </h3>
//                 <div className="mt-2 p-2 bg-gray-50 dark:bg-gray-700 rounded">
//                   <pre className="whitespace-pre-wrap dark:text-white">
//                     {selectedTask.description || "No description provided"}
//                   </pre>
//                 </div>
//               </div>

//               {/* Status Updates */}
//               {selectedTask.statusUpdates?.length > 0 && (
//                 <div className="md:col-span-2">
//                   <h3 className="text-lg font-semibold text-gray-800 dark:text-white border-b pb-2">
//                     Status History
//                   </h3>
//                   <div className="mt-2 space-y-2">
//                     {selectedTask.statusUpdates.map((update, idx) => (
//                       <div
//                         key={idx}
//                         className="p-2 border-b dark:border-gray-700"
//                       >
//                         <div className="flex flex-wrap gap-1">
//                           <span className="font-medium">
//                             {update.updatedByName}
//                           </span>
//                           <span>changed status from</span>
//                           <span className="font-medium">
//                             {update.oldStatus || "None"}
//                           </span>
//                           <span>to</span>
//                           <span className="font-medium">
//                             {update.newStatus}
//                           </span>
//                         </div>
//                         <div className="text-sm text-gray-500 dark:text-gray-400">
//                           {formatDate(
//                             new Date(update.updatedAt).toLocaleString(),
//                           )}
//                         </div>
//                         {update.remark && (
//                           <div className="text-sm text-gray-600 dark:text-gray-300 mt-1">
//                             <span className="font-medium">Remark:</span>{" "}
//                             {update.remark}
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }










import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import {
  FaEdit,
  FaTrash,
  FaChevronDown,
  FaChevronUp,
  FaEye,
  FaPlusCircle,
  FaReply,
  FaCommentDots,
  FaSearch,
  FaTimes,
  FaTicketAlt,
  FaDownload,
  FaCommentAlt,
  FaList,
} from "react-icons/fa";
import { XMarkIcon } from "@heroicons/react/24/solid";
import Select from "react-select";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { toast } from "react-toastify";

export default function TaskTableView({ refreshTrigger }) {
  const { user } = useContext(AuthContext);
  const [tasks, setTasks] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [labels, setLabels] = useState([]);
  const [users, setUsers] = useState([]);
  const [expandedTask, setExpandedTask] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [statusUpdates, setStatusUpdates] = useState([]);
  const [comments, setComments] = useState([]);
  const [ticketDetails, setTicketDetails] = useState(null);
  const [isCommentBoxOpen, setIsCommentBoxOpen] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editedTask, setEditedTask] = useState({});
  const [isResponseModalOpen, setIsResponseModalOpen] = useState(false);
  const [responseData, setResponseData] = useState({ content: "", file: null });
  const [taskResponses, setTaskResponses] = useState([]);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [taskToDelete, setTaskToDelete] = useState(null);
  const [searchParams, setSearchParams] = useState({
    subject: "",
    priority: "",
    labelName: "",
    targetUserId: "",
    startDate: "",
    endDate: "",
  });
  const [isSearching, setIsSearching] = useState(false);
  const [showFields, setShowFields] = useState(false);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [currentAttachment, setCurrentAttachment] = useState(null);
  const [attachmentType, setAttachmentType] = useState("");
  const [attachmentFilename, setAttachmentFilename] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [abortController, setAbortController] = useState(new AbortController());
  const [isLoading, setIsLoading] = useState(false);
  const [editModalData, setEditModalData] = useState(null); // response to edit
  const [updatedContent, setUpdatedContent] = useState("");
  const [updatedFile, setUpdatedFile] = useState(null);
  const [currentResponseFile, setCurrentResponseFile] = useState(null);
  const [responseFileModalOpen, setResponseFileModalOpen] = useState(false);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(""); // "APPROVED" or "REJECTED"
  const [showRemarkInput, setShowRemarkInput] = useState(false);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editedComment, setEditedComment] = useState("");
  const [showCommentBoxId, setShowCommentBoxId] = useState(null);
  const [commentInput, setCommentInput] = useState("");
  const [editingComment, setEditingComment] = useState(null);
  const token = localStorage.getItem("token");
  const [statusUpdateModalOpen, setStatusUpdateModalOpen] = useState(false);
  const [commentLengthError, setCommentLengthError] = useState("");
  const [selectedStatusUpdate, setSelectedStatusUpdate] = useState({
    taskId: null,
    newStatus: "",
    remark: "",
  });
  const [participantEmail, setParticipantEmail] = useState("");
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [pendingParticipant, setPendingParticipant] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [taskDetailsModalOpen, setTaskDetailsModalOpen] = useState(false);

  // Fetch Statuses & Labels
  useEffect(() => {
    async function fetchStatusAndLabel() {
      const companyId =
        user?.accountType === "COMPANY" ? user.id : user?.companyId;
      // if (!companyId) return;

      try {
        const statusResponse = await axios.get(
          `${API_URL}/api/taskStatus/company/${companyId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        const labelResponse = await axios.get(
          `${API_URL}/api/taskLabel/company/${companyId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        setStatuses(statusResponse.data);
        setLabels(labelResponse.data);
      } catch (error) {
        console.error("Error fetching statuses and labels:", error);
      }
    }
    fetchStatusAndLabel();
  }, [user]);

  // Fetch Users
  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;
      const url =
        user?.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await axios.get(url, {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [user]);

  const handleEditClick = (task) => {
    setEditedTask({
      ...task,
      assignedToJson: JSON.stringify(task.assignedTo),
    });
    const participantEmails =
      task.participants?.map((p) => (Array.isArray(p) ? p[1] || p[0] : p)) ||
      [];
    setParticipants(participantEmails);
    setEditModalOpen(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedTask((prev) => ({ ...prev, [name]: value }));
    setResponseData((prev) => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = async (taskId, newStatus) => {
    setSelectedStatusUpdate({
      taskId,
      newStatus,
      remark: "",
    });
    setStatusUpdateModalOpen(true);
  };

  // Add this function to submit the status update
  const handleStatusUpdateSubmit = async () => {
    if (!selectedStatusUpdate.remark.trim()) {
      toast.error("Please enter a remark");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${API_URL}/api/tasks/updateStatus/${selectedStatusUpdate.taskId}`,
        {
          newStatus: selectedStatusUpdate.newStatus,
          remark: selectedStatusUpdate.remark,
          updatedById: user.id,
          updatedByName: user.name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.status === "Successful") {
        toast.success(response.data.message);
        setStatusUpdateModalOpen(false);
        fetchPage(pageNumber); // Refresh the current page
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating task status:", error);
      toast.error(error.response?.data?.message);
    }
  };

  const handleLabelChange = (e) => {
    const selectedLabel = labels.find((label) => label.name === e.target.value);
    setEditedTask((prev) => ({
      ...prev,
      labelName: e.target.value,
      labelColor: selectedLabel ? selectedLabel.color : "",
    }));
  };

  const handleAssignedUsersChange = (selectedOptions) => {
    const assignedUsers = selectedOptions.map((option) => ({
      id: option.value,
      name: option.label,
    }));
    setEditedTask((prev) => ({
      ...prev,
      assignedToJson: JSON.stringify(assignedUsers),
    }));
  };

  // In your edit modal's form, ensure all required fields are properly handled
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();

    // Add validation if needed
    if (!editedTask.subject) {
      toast.error("Subject is required");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("subject", editedTask.subject);
      formData.append("priority", editedTask.priority || "Low");
      if (editedTask.labelName)
        formData.append("labelName", editedTask.labelName);
      if (editedTask.labelColor)
        formData.append("labelColor", editedTask.labelColor);
      if (editedTask.endDate) formData.append("endDate", editedTask.endDate);
      if (editedTask.description)
        formData.append("description", editedTask.description);
      if (editedTask.assignedToJson)
        formData.append("assignedToJson", editedTask.assignedToJson);
      if (editedTask.file) formData.append("file", editedTask.file);
      participants.forEach((participant) => {
        const value = Array.isArray(participant)
          ? participant[1] || participant[0]
          : participant;
        formData.append("participants", value.trim());
      });

      const response = await axios.put(
        `${API_URL}/api/tasks/${editedTask.taskId}/updatedBy/${user.id}/updatedByName/${user.name}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      toast.success(response.data.message);
      setEditModalOpen(false);
      fetchPage(pageNumber); // Refresh the first page
    } catch (error) {
      console.error("Error updating task:", error);
      toast.error(error.response?.data?.message);
    }
  };

  // Handle search input changes
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle search submit
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    setIsSearching(true);
    setPageNumber(0);

    try {
      const companyId =
        user?.accountType === "COMPANY" ? user.id : user?.companyId;
      if (!companyId) return;

      // Remove empty params
      const params = Object.fromEntries(
        Object.entries(searchParams).filter(([_, v]) => v !== ""),
      );

      // Add pagination parameters
      params.pageNumber = pageNumber;
      params.pageSize = pageSize;

      const response = await axios.get(
        `${API_URL}/api/tasks/search/${companyId}/${user?.id}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      setTasks(response.data.tasks || []);
      setTotalPages(response.data?.totalPages || 0);
      toast.success(`Found ${response.data?.tasks?.length || 0} results`);
    } catch (error) {
      console.error("Search failed:", error);
      toast.error("Failed to search tasks");
      setTasks([]);
      setTotalPages(0);
    }
  };

  // Clear search and reset to normal view
  const handleClearSearch = () => {
    setIsSearching(false);
    setSearchParams({
      subject: "",
      priority: "",
      labelName: "",
      targetUserId: "",
      startDate: "",
      endDate: "",
    });
    setPageNumber(0);
    fetchPage(0);
  };

  const fetchPage = async (page) => {
    setIsLoading(true);

    // Cancel any pending requests
    abortController.abort();
    const newAbortController = new AbortController();
    setAbortController(newAbortController);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token missing");
        return;
      }

      let response;
      const params = {
        pageNumber: page,
        pageSize: pageSize,
      };

      if (isSearching) {
        const companyId =
          user?.accountType === "COMPANY" ? user.id : user?.companyId;
        // Add search params
        Object.entries(searchParams).forEach(([key, value]) => {
          if (value) params[key] = value;
        });

        response = await axios.get(
          `${API_URL}/api/tasks/search/${companyId}/${user?.id}`,
          {
            params,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            signal: newAbortController.signal,
          },
        );
      } else {
        let endpoint = "";
        if (!user?.id) return;

        if (user.accountType === "COMPANY") {
          endpoint = `${API_URL}/api/tasks/company/${user.id}`;
        } else {
          endpoint = `${API_URL}/api/tasks/forUser/${user.id}`;
        }

        response = await axios.get(
          `${endpoint}?pageNumber=${page}&pageSize=${pageSize}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            signal: newAbortController.signal,
          },
        );
      }

      // Handle response
      const tasks = Array.isArray(response.data?.tasks)
        ? response.data.tasks
        : [];
      const total = response.data?.totalPages || 0;

      setTasks(tasks);
      setTotalPages(total);
      setPageNumber(page);
    } catch (err) {
      if (err.name === "AbortError" || axios.isCancel(err)) return;
      console.error("Error fetching tasks:", err);
      setTasks([]);
      setTotalPages(0);
      toast.error(err.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleTaskCreated = () => {
      // Your data fetching logic here
      setPageNumber(0);
      fetchPage(0);
    };

    window.addEventListener("taskCreated", handleTaskCreated);

    return () => {
      window.removeEventListener("taskCreated", handleTaskCreated);
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    setAbortController(controller);

    setPageNumber(0);
    fetchPage(0);

    return () => {
      controller.abort();
    };
  }, [pageSize, isSearching, refreshTrigger, user]);

  const toggleDropdown = (taskId) => {
    setExpandedTask(expandedTask === taskId ? null : taskId);
  };

  const handleViewTicket = async (task) => {
    setSelectedTask(task);
    setIsModalOpen(true);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/api/tickets/by-reference/${task.taskId}?referenceType=TASK`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const ticketData = response.data;
      setTicketDetails(ticketData);

      setComments(ticketData.comments || []);
      setStatusUpdates(task.statusUpdates || []);
    } catch (error) {
      console.error("Error fetching ticket details:", error);
    }
  };

  const handleAddComment = async () => {
    if (newComment.trim().length > 150) {
      setCommentLengthError("comment must not exceed 150 characters");
      return;
    }

    try {
      await axios.post(
        `${API_URL}/api/tickets/addComment/${ticketDetails.ticketId}`,
        {
          userId: user.id,
          userName: user.name,
          content: newComment,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setComments((prev) => [
        ...prev,
        {
          content: newComment,
          userName: user.name,
          createdAt: new Date().toISOString(),
        },
      ]);
      handleViewTicket();
      setNewComment("");
      setCommentLengthError("");
      setIsCommentBoxOpen(false);
    } catch (error) {
      console.error("Failed to post comment:", error);
    }
  };

  const handleCloseButton = () => {
    setIsModalOpen(false);
    setIsCommentBoxOpen(false);
    setNewComment("");
  };

  const handleResponseClick = (task) => {
    setSelectedTask(task);
    setIsResponseModalOpen(true);
  };

  const handleFileChange = (e) => {
    setResponseData((prev) => ({ ...prev, file: e.target.files[0] }));
  };

  const handleResponseSubmit = async () => {
    if (!selectedTask) {
      toast.error("No task selected.");
      return;
    }

    const formData = new FormData();
    formData.append("content", responseData.content);
    formData.append("userId", user?.id);
    formData.append("userName", user?.name);
    if (responseData.file) {
      formData.append("file", responseData.file);
    }

    try {
      const res = await fetch(
        `${API_URL}/api/tasks/addResponse/${selectedTask?.taskId}`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const responseData = await res.json(); // Add this line to parse the JSON response

      if (res.ok) {
        toast.success(responseData.message); // Use responseData instead of response
        setIsResponseModalOpen(false);
        setResponseData({ content: "", file: null });
        handleViewResponse(selectedTask.taskId);
      } else {
        toast.error("Failed to submit response.");
      }
    } catch (err) {
      console.error("Error submitting response:", err);
      toast.error("Something went wrong while submitting response.");
    }
  };

  const handleViewResponse = async (clickedTaskId) => {
    try {
      const endpoint =
        user.accountType === "COMPANY"
          ? `${API_URL}/api/tasks/company/${user.id}`
          : `${API_URL}/api/tasks/forUser/${user.id}`;

      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      const allTasks = Array.isArray(response.data.tasks)
        ? response.data.tasks
        : [];

      // Find the selected task using taskId
      const foundTask = allTasks.find((task) => task.taskId === clickedTaskId);
      if (!foundTask) return;

      // Set the task and its responses from task object
      setSelectedTask(foundTask);
      setTaskResponses(foundTask.taskResponse || []);

      // Open modal
      setIsViewModalOpen(true);
    } catch (error) {
      console.error("Error in handleViewResponse:", error);
    }
  };

  const handleDeleteResponse = async (responseId, taskId) => {
    try {
      await axios.delete(
        `${API_URL}/api/tasks/deleteResponse/${selectedTask.taskId}/${responseId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      // Refetch tasks after delete to keep UI updated
      handleViewResponse(selectedTask.taskId);
    } catch (error) {
      console.error("Error deleting response:", error);
    }
  };

  const handleDeleteTask = async (taskId) => {
    try {
      await axios.delete(`${API_URL}/api/tasks/deleteTask/${taskId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      toast.success("Task deleted successfully");
      setShowDeleteModal(false);
      setTaskToDelete(null);
      fetchPage(0); // refresh task list
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error(error.response?.data?.message || "Failed to delete task");
    }
  };

  const handleViewAttachment = async (task) => {
    try {
      if (!task.attachment || task.attachment === "null") {
        toast.error("No attachment found");
        return;
      }

      const filename = task.attachment;
      const fileExtension = filename.split(".").pop().toLowerCase();

      // Determine type category
      let typeCategory = "other";
      if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
        typeCategory = "image";
      } else if (["mp4", "webm", "ogg"].includes(fileExtension)) {
        typeCategory = "video";
      } else if (["mp3", "wav", "ogg"].includes(fileExtension)) {
        typeCategory = "audio";
      } else if (fileExtension === "pdf") {
        typeCategory = "pdf";
      } else if (
        ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)
      ) {
        typeCategory = "unsupported";
      } else if (["txt", "csv"].includes(fileExtension)) {
        typeCategory = "text";
      }

      // Show error for unsupported types
      if (typeCategory === "unsupported") {
        toast.error("Preview not available for this file type");
        return;
      }

      // Fetch file
      const response = await axios.get(
        `${API_URL}/api/tasks/view/${task.taskId}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      // Create object URL
      const blobType =
        typeCategory === "pdf" ? "application/pdf" : response.data.type;
      const blob = new Blob([response.data], { type: blobType });
      const fileUrl = URL.createObjectURL(blob);

      // If PDF on mobile, open in new tab instead of modal
      const isMobile = window.innerWidth < 768;
      if (typeCategory === "pdf" && isMobile) {
        window.open(fileUrl, "_blank");
        return;
      }

      setCurrentAttachment(fileUrl);
      setAttachmentFilename(filename);
      setAttachmentType(typeCategory);
      setShowAttachmentModal(true);
    } catch (error) {
      toast.error("Failed to view attachment");
      console.error(error);
    }
  };

  const handleDownloadAttachment = async (task) => {
    try {
      if (!task.attachment || task.attachment === "null") {
        toast.error("No attachment found");
        return;
      }

      const response = await axios.get(
        `${API_URL}/api/tasks/download/${task.taskId}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      // Use the filename from the task's attachment field
      const filename = task.attachment;

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Failed to download attachment");
      console.error(error);
    }
  };

  const getOfficeViewerUrl = (fileUrl) => {
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
      fileUrl,
    )}`;
  };

  // const handleTabChange = (tab) => {
  //   setActiveTab(tab);
  //   setPageNumber(0); // Reset to first page
  //   setIsSearching(false); // Clear any search state
  //   setTasks([]);
  // };

  const handleViewFile = async (res) => {
    try {
      if (!res.attachment || res.attachment === "null") {
        toast.error("No attachment found");
        return;
      }

      const taskId = selectedTask?.taskId;
      const filename = res.attachment;
      const fileExtension = filename.split(".").pop().toLowerCase();

      // Determine type category (same as handleViewAttachment)
      let typeCategory = "other";
      if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
        typeCategory = "image";
      } else if (["mp4", "webm", "ogg"].includes(fileExtension)) {
        typeCategory = "video";
      } else if (["mp3", "wav", "ogg"].includes(fileExtension)) {
        typeCategory = "audio";
      } else if (fileExtension === "pdf") {
        typeCategory = "pdf";
      } else if (
        ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)
      ) {
        typeCategory = "office";
      } else if (["txt", "csv"].includes(fileExtension)) {
        typeCategory = "text";
      }

      // Show error for unsupported types
      if (typeCategory === "unsupported") {
        toast.error("Preview not available for this file type");
        return;
      }

      // Fetch file
      const response = await axios.get(
        `${API_URL}/api/tasks/viewResponseFile/${taskId}/${res.id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      // Create object URL
      const blobType =
        typeCategory === "pdf" ? "application/pdf" : response.data.type;
      const blob = new Blob([response.data], { type: blobType });
      const fileUrl = URL.createObjectURL(blob);

      // If PDF on mobile, open in new tab instead of modal
      const isMobile = window.innerWidth < 768;
      if (typeCategory === "pdf" && isMobile) {
        window.open(fileUrl, "_blank");
        return;
      }

      setCurrentResponseFile({
        url: fileUrl,
        type: typeCategory,
        name: filename,
      });
      setResponseFileModalOpen(true);
    } catch (error) {
      console.error("Error viewing file:", error);
      toast.error(
        "Failed to view attachment. You can try downloading it instead.",
      );
    }
  };

  const handleDownloadFile = async (res) => {
    try {
      if (!res.attachment || res.attachment === "null") {
        toast.error("No attachment found");
        return;
      }

      const taskId = selectedTask?.taskId;
      const response = await axios.get(
        `${API_URL}/api/tasks/downloadResponseFile/${taskId}/${res.id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      // Get filename from Content-Disposition header or use the stored filename
      const contentDisposition = response.headers["content-disposition"];
      let filename = res.attachment;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error("Failed to download attachment");
    }
  };

  const handleEditResponse = (res) => {
    setEditModalData(res);
    setUpdatedContent(res.content);
    setUpdatedFile(null); // clear previous file if any
  };

  const handleUpdateResponse = async () => {
    const formData = new FormData();
    if (updatedFile) formData.append("file", updatedFile);

    formData.append("taskId", selectedTask.taskId);
    formData.append("userId", user.id);
    formData.append("userName", user.name);
    formData.append("content", updatedContent);

    try {
      await axios.put(
        `${API_URL}/api/tasks/updateResponse/${editModalData.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      setEditModalData(null);
      setUpdatedContent("");
      setUpdatedFile(null);

      handleViewResponse(selectedTask.taskId); // refresh list
    } catch (err) {
      console.error("Error updating response:", err);
    }
  };

  const handleApproveOrReject = async (taskId, newStatus, remark) => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${API_URL}/api/tasks/approveOrReject/${taskId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            newStatus,
            updatedById: user?.id,
            updatedByName: user?.name,
            remark,
          }),
        },
      );

      if (response.ok) {
        // 1. Clear remark input
        setRemarkInput("");

        // 2. Close remark input UI
        setShowRemarkInput(false);

        // 3. Close modal
        setIsModalOpen(false);

        // 4. Update local state immediately
        setSelectedTask((prev) => ({
          ...prev,
          statusName: newStatus,
          statusColor:
            newStatus === "APPROVED"
              ? "#10b981"
              : newStatus === "REJECTED"
                ? "#ef4444"
                : "#e5e7eb",
          statusUpdates: [
            ...(prev.statusUpdates || []),
            {
              newStatus,
              updatedAt: new Date().toISOString(),
              updatedByName: user?.name,
              remark,
            },
          ],
        }));

        // 5. Show success notification
        toast.success(`Ticket ${newStatus.toLowerCase()} successfully!`);
        handleViewTicket();
        fetchPage(pageNumber);
      } else {
        toast.error("Failed to update task status");
        console.error("Failed to update task status");
      }
    } catch (error) {
      toast.error("Error updating ticket status");
      console.error("Error:", error);
    }
  };

  const handleUpdateComment = async (ticketId, commentId, updatedContent) => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.put(
        `${API_URL}/api/tickets/updateComment/${ticketId}/${commentId}`,
        updatedContent,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "text/plain",
          },
        },
      );

      // Clear editing state
      setEditingCommentId(null);
      setEditedComment("");

      // Update comments list
      const ticketData = response.data;
      setTicketDetails(ticketData);
      setComments(ticketData.comments || []);

      toast.success("Comment updated successfully");
    } catch (error) {
      console.error("Error updating comment:", error);
      toast.error("Failed to update comment");
    }
  };

  const handleDeleteComment = async (commentId) => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.delete(
        `${API_URL}/api/tickets/deleteComment/${ticketDetails.ticketId}/${commentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const ticketData = response.data;
      setTicketDetails(ticketData);
      setComments(ticketData.comments || []);
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  const toggleCommentBox = (responseId) => {
    if (showCommentBoxId === responseId) {
      setShowCommentBoxId(null);
      setCommentInput("");
      setEditingComment(null);
    } else {
      setShowCommentBoxId(responseId);
      setCommentInput("");
      setEditingComment(null);
    }
  };

  // Submit or update comment
  const submitComment = async (responseId) => {
    if (!commentInput.trim()) return;
    const commentId = editingComment?.commentId;

    try {
      const url = editingComment
        ? `${API_URL}/api/tasks/updateResponseComment/${selectedTask.taskId}/${responseId}/${commentId}`
        : `${API_URL}/api/tasks/addResponseComment/${selectedTask.taskId}/${responseId}`;

      const method = editingComment ? "PUT" : "POST";

      const bodyData = {
        content: commentInput,
        userId: user?.id,
        userName: user?.name,
      };

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: editingComment ? commentInput : JSON.stringify(bodyData),
      });

      if (res.ok) {
        setCommentInput("");
        setShowCommentBoxId(null);
        setEditingComment(null);
        handleViewResponse(selectedTask.taskId);
        toast.success(editingComment ? "Comment updated!" : "Comment added!");
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  // Start editing
  const handleEditComment = (responseId, comment) => {
    setShowCommentBoxId(responseId);
    setCommentInput(comment.content);
    setEditingComment(comment);
  };

  // Delete comment
  const handleDeleteResponseComment = async (responseId, commentId) => {
    try {
      const res = await fetch(
        `${API_URL}/api/tasks/deleteResponseComment/${selectedTask.taskId}/${responseId}/${commentId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (res.ok) {
        await handleViewResponse(selectedTask.taskId);
        toast.success("Comment deleted!");
      }
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  // Update the participant handling functions
  const handleAddParticipant = () => {
    if (!participantEmail) return;

    const matchedUser = users.find((u) => u.email === participantEmail);
    if (matchedUser) {
      setPendingParticipant({ id: matchedUser.id, email: participantEmail });
      setShowNotifyModal(true);
    } else {
      setParticipants((prev) => [...prev, participantEmail]);
      setParticipantEmail("");
    }
  };

  const confirmParticipant = (type) => {
    let entry =
      type === "both"
        ? [pendingParticipant.id, pendingParticipant.email]
        : [pendingParticipant.email];

    setParticipants((prev) => [...prev, entry]);
    setShowNotifyModal(false);
    setPendingParticipant(null);
    setParticipantEmail("");
  };

  const handleViewTaskDetails = (task) => {
    setSelectedTask(task);
    setTaskDetailsModalOpen(true);
  };

  // helper section for rendering for the date and  n formate of the DD-MM-YYYY adding date 27-01-2026
  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="p-2 dark:bg-gray-900 dark:text-gray-100">
      <div className="flex flex-col gap-4 mb-4 sm:flex-row sm:justify-between sm:items-center">
        {/* Heading: top on small, left on large */}
        <div className="flex justify-start">
          <h2 className="text-xl font-bold">Task Table</h2>
        </div>

        {/* Search button: center on mobile, right on large */}
        <div className="flex flex-wrap justify-end">
          <button
            type="button"
            onClick={() => setShowFields(!showFields)}
            className="px-2 py-1 bg-[#673AB7] text-white hover:bg-[#5e35a6] rounded-lg flex items-center"
          >
            {showFields ? (
              <>
                <FaTimes className="mr-2 w-5 h-4" />
                Close
              </>
            ) : (
              <>
                <FaSearch className="mr-2 w-5 h-4" />
                Search
              </>
            )}
          </button>
        </div>
      </div>

      {showFields && (
        <form
          onSubmit={handleSearchSubmit}
          className="p-2 bg-white dark:bg-gray-800 shadow rounded-lg mb-4"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 items-end">
            {/* Subject */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Subject
              </label>
              <input
                type="text"
                name="subject"
                value={searchParams.subject}
                onChange={handleSearchChange}
                placeholder="Search by subject"
                className="w-full p-1 border rounded-lg bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
            </div>

            {/* Priority */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Priority
              </label>
              <select
                name="priority"
                value={searchParams.priority}
                onChange={handleSearchChange}
                className="w-full p-1 border rounded-lg bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="">All</option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>

            {/* Label */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Label
              </label>
              <select
                name="labelName"
                value={searchParams.labelName}
                onChange={handleSearchChange}
                className="w-full p-1 border rounded-lg bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="">All</option>
                {labels.map((label) => (
                  <option key={label.id} value={label.name}>
                    {label.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Created By */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                User
              </label>
              <select
                name="targetUserId"
                value={searchParams.targetUserId}
                onChange={handleSearchChange}
                className="w-full p-1 border rounded-lg bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="">All</option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.fname} {user.lname}
                  </option>
                ))}
              </select>
            </div>

            {/* Date Range */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Date Range
              </label>
              <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
                <input
                  type="date"
                  name="startDate"
                  value={searchParams.startDate}
                  onChange={handleSearchChange}
                  className="sm:w-1/2 mb-2 sm:mb-0 p-1 border rounded-lg bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
                <span className="text-center sm:text-left text-gray-500 dark:text-gray-300">
                  to
                </span>
                <input
                  type="date"
                  name="endDate"
                  value={searchParams.endDate}
                  onChange={handleSearchChange}
                  className="sm:w-1/2 mt-2 sm:mt-0 p-1 border rounded-lg bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-2 mt-2">
            <button
              type="submit"
              className="px-2 py-1 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6] flex items-center"
            >
              <FaSearch className="mr-2" />
              Search
            </button>
            {isSearching && (
              <button
                type="button"
                onClick={handleClearSearch}
                className="px-2 py-1 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 flex items-center"
              >
                <FaTimes className="mr-2" />
                Clear
              </button>
            )}
          </div>
        </form>
      )}

      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300 dark:border-gray-600 text-xs">
          <thead>
            <tr className="bg-gray-100 dark:bg-gray-700 dark:text-white text-left">
              <th className="p-1">S No.</th>
              <th className="p-1">Subject</th>
              <th className="p-1">Priority</th>
              <th className="p-1">Assigned Date</th>
              <th className="p-1">End Date</th>
              <th className="p-1">Assigned By</th>
              <th className="p-1">Assigned To</th>

              <th className="p-1">Status</th>
              <th className="p-1">Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="9" className="text-center p-4">
                  Loading...
                </td>
              </tr>
            ) : tasks.length > 0 ? (
              tasks.map((task, index) => (
                <React.Fragment key={task.taskId}>
                  <tr className="border-b border-gray-300 dark:border-gray-600 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700">
                    <td className="p-1">
                      <div className="flex items-center gap-2">
                        {index + 1}.
                        <FaList
                          className="text-[#673AB7] cursor-pointer hover:text-[#5e35a6]"
                          onClick={() => handleViewTaskDetails(task)}
                          title="View task details"
                        />
                      </div>
                    </td>
                    <td className="p-1 flex items-center   justify-between">
                      {/* <span>{task.subject}</span> */}
                      <span
                        className="max-w-[190px] truncate cursor-pointer"
                        title={task.subject}
                      >
                        {task.subject}
                      </span>
                      <span
                        onClick={() => toggleDropdown(task.taskId)}
                        className="ml-2 cursor-pointer"
                      >
                        {expandedTask === task.taskId ? (
                          <FaChevronUp className="text-gray-500" />
                        ) : (
                          <FaChevronDown className="text-gray-500" />
                        )}
                      </span>
                    </td>
                    <td className="p-1">{task.priority}</td>
                    {/* <td className="p-1">{task.startDate}</td> */}
                    {/* <td className="p-1">{task.endDate}</td> */}
                    <td className="p-1">{formatDate(task.startDate)}</td>
                    <td className="p-1">{formatDate(task.endDate)}</td>

                    <td className="p-1">{task.createdByName}</td>
                    <td className="p-1">
                      {task.assignedTo.map((assignee, idx) => (
                        <span key={idx}>
                          {assignee.name}
                          <br />
                        </span>
                      ))}
                    </td>

                    <td className="p-1">
                      <select
                        className="border p-1 rounded-lg dark:bg-gray-900 dark:text-white"
                        value={task.statusName}
                        onChange={(e) =>
                          handleStatusChange(task.taskId, e.target.value)
                        }
                      >
                        {statuses
                          .filter((status) => status.active === true)
                          .map((status) => (
                            <option
                              key={status.id} // Use unique id if available
                              value={status.name} // This value gets passed to onChange
                            >
                              {status.name}
                            </option>
                          ))}
                      </select>
                    </td>

                    <td className="p-1 space-x-1 flex flex-wrap">
                      {task.createdById === user?.id ||
                      user?.accountType === "COMPANY" ? (
                        <>
                          <FaEdit
                            title="Edit"
                            className="cursor-pointer text-[#673AB7] hover:text-[#5e35a6] dark:hover:text-purple-300"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditClick(task);
                            }}
                          />
                          <FaTrash
                            title="Delete"
                            className="cursor-pointer text-red-500 hover:text-red-700 dark:hover:text-red-300"
                            onClick={(e) => {
                              e.stopPropagation();
                              setTaskToDelete(task);
                              setShowDeleteModal(true);
                            }}
                          />
                        </>
                      ) : null}

                      {/* Common icons shown for all users */}
                      <FaReply
                        title="Respond"
                        className="cursor-pointer text-[#673AB7] hover:text-[#5e35a6] dark:hover:text-purple-300"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleResponseClick(task);
                        }}
                      />
                      <FaTicketAlt
                        title="View Ticket"
                        className="cursor-pointer text-green-600 hover:text-green-800 dark:hover:text-green-300"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewTicket(task);
                        }}
                      />
                      <FaCommentDots
                        title="View Response"
                        className="cursor-pointer text-[#673AB7] hover:text-[#5e35a6] dark:hover:text-purple-300"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewResponse(task.taskId);
                        }}
                      />

                      {task.attachment && task.attachment !== "null" && (
                        <>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedTask(task);
                              handleViewAttachment(task);
                            }}
                            className="text-[#673AB7] hover:text-[#5e35a6] dark:hover:text-purple-300"
                            title="View Attachment"
                          >
                            <FaEye />
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDownloadAttachment(task);
                            }}
                            className="text-green-500 hover:text-green-700 dark:hover:text-green-300"
                            title="Download Attachment"
                          >
                            <FaDownload />
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                  {expandedTask === task.taskId && (
                    <tr>
                      <td
                        colSpan="9"
                        className="p-2 bg-gray-50 dark:bg-gray-800 dark:bg-gray-800"
                      >
                        <strong>Description:</strong>
                        <pre
                          style={{
                            whiteSpace: "pre-wrap",
                            wordWrap: "break-word",
                            maxWidth: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            overflowY: "auto",
                            padding: "6px",
                            margin: "0",
                            // backgroundColor: '#f8f9fa',
                            borderRadius: "4px",
                          }}
                        >
                          {task.description}
                        </pre>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center p-4">
                  "No records found"
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 0 && (
        <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4">
          <div className="flex items-center gap-2 w-full sm:w-auto relative z-10">
            <span className="text-sm text-gray-600 dark:text-gray-300 whitespace-nowrap">
              Items per page:
            </span>
            <Select
              className="w-20 sm:w-24 text-sm"
              classNamePrefix="select"
              menuPortalTarget={
                typeof window !== "undefined" ? document.body : null
              }
              menuPosition="fixed"
              styles={{
                control: (baseStyles, state) => {
                  const isDark =
                    typeof window !== "undefined" &&
                    document.documentElement.classList.contains("dark");
                  return {
                    ...baseStyles,
                    backgroundColor: isDark ? "#374151" : "#ffffff",
                    color: isDark ? "#ffffff" : "#000000",
                    borderColor: isDark ? "#4b5563" : "#d1d5db",
                    minHeight: "32px",
                    fontSize: "0.875rem",
                    zIndex: 10,
                  };
                },
                singleValue: (base) => {
                  const isDark =
                    typeof window !== "undefined" &&
                    document.documentElement.classList.contains("dark");
                  return {
                    ...base,
                    color: isDark ? "#ffffff" : "#000000",
                  };
                },
                menu: (base) => {
                  const isDark =
                    typeof window !== "undefined" &&
                    document.documentElement.classList.contains("dark");
                  return {
                    ...base,
                    backgroundColor: isDark ? "#1f2937" : "#ffffff",
                    color: isDark ? "#ffffff" : "#000000",
                    zIndex: 9999,
                  };
                },
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                option: (base, state) => {
                  const isDark =
                    typeof window !== "undefined" &&
                    document.documentElement.classList.contains("dark");
                  return {
                    ...base,
                    backgroundColor: state.isFocused
                      ? isDark
                        ? "#4b5563"
                        : "#e5e7eb"
                      : isDark
                        ? "#1f2937"
                        : "#ffffff",
                    color: isDark ? "#ffffff" : "#000000",
                    cursor: "pointer",
                  };
                },
              }}
              value={{ value: pageSize, label: pageSize.toString() }}
              onChange={(selectedOption) => {
                setPageSize(Number(selectedOption.value));
                setPageNumber(0);
                fetchPage(0);
              }}
              options={[
                { value: 5, label: "5" },
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 50, label: "50" },
              ]}
            />
          </div>
          <div className="flex flex-wrap justify-center items-center gap-1 sm:gap-2 w-full sm:w-auto">
            <button
              onClick={() => {
                setPageNumber(0);
                fetchPage(0);
              }}
              className="px-2 sm:px-4 py-1 bg-purple-100 hover:bg-purple-200 text-xs sm:text-sm text-purple-800 rounded-lg disabled:opacity-50"
              disabled={pageNumber === 0}
            >
              First
            </button>
            <button
              onClick={() => {
                const newPage = Math.max(pageNumber - 1, 0);
                setPageNumber(newPage);
                fetchPage(newPage);
              }}
              className="px-2 sm:px-4 py-1 bg-purple-100 hover:bg-purple-200 text-xs sm:text-sm text-purple-800 rounded-lg disabled:opacity-50"
              disabled={pageNumber === 0}
            >
              Prev
            </button>

            <span className="text-xs sm:text-sm font-medium px-2">
              Page {pageNumber + 1} of {totalPages}
            </span>

            <button
              onClick={() => {
                const newPage = Math.min(pageNumber + 1, totalPages - 1);
                setPageNumber(newPage);
                fetchPage(newPage);
              }}
              className="px-2 sm:px-4 py-1 bg-purple-100 hover:bg-purple-200 text-xs sm:text-sm text-purple-800 rounded-lg disabled:opacity-50"
              disabled={pageNumber >= totalPages - 1}
            >
              Next
            </button>
            <button
              onClick={() => {
                setPageNumber(totalPages - 1);
                fetchPage(totalPages - 1);
              }}
              className="px-2 sm:px-4 py-1 bg-purple-100 hover:bg-purple-200 text-xs sm:text-sm text-purple-800 rounded-lg disabled:opacity-50"
              disabled={pageNumber >= totalPages - 1}
            >
              Last
            </button>
          </div>
        </div>
      )}

      {isModalOpen && selectedTask && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-2 sm:p-4 animate-fade-in">
          <div className="bg-white dark:bg-gray-800 dark:text-white p-4 sm:p-6 rounded-xl w-full max-w-4xl mx-auto max-h-[90vh] overflow-y-auto shadow-xl border border-gray-200 dark:border-gray-700">
            {/* Header */}
            <div className="flex justify-between items-center border-b pb-3 mb-3">
              <h2 className="text-xl sm:text-2xl dark:text-white font-semibold text-gray-800 flex items-center gap-2">
                🧾 Ticket Details
              </h2>
              <button
                onClick={handleCloseButton}
                className="text-gray-500 hover:text-red-500 dark:text-white text-xl transition duration-150"
              >
                ✖
              </button>
            </div>

            {/* Basic Info */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-1 sm:gap-4 mb-4 text-sm sm:text-base text-gray-700">
              <div>
                <span className="font-semibold dark:text-white text-gray-900">
                  Assigned To:
                </span>
                <span className="dark:text-white mx-2">
                  {selectedTask.assignedTo?.map((u) => u.name).join(", ") ||
                    "_"}
                </span>
              </div>
              <div>
                <span className="font-semibold dark:text-white text-gray-900">
                  Status:
                </span>
                <span className="mx-2">
                  {selectedTask.statusUpdates?.[
                    selectedTask.statusUpdates.length - 1
                  ]?.newStatus === "PENDING_APPROVAL" &&
                  selectedTask.createdById === user?.id ? (
                    <div className="flex items-center flex-wrap gap-2 mt-1">
                      <span className="inline-block px-2 py-1 rounded-lg text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200">
                        {selectedTask.statusUpdates?.[
                          selectedTask.statusUpdates.length - 1
                        ]?.newStatus || "Pending"}
                      </span>
                      <button
                        className="text-green-600 hover:scale-110"
                        title="Approve"
                        onClick={() => {
                          setActionType("APPROVED");
                          setShowRemarkInput(true);
                        }}
                      >
                        ✅
                      </button>
                      <button
                        className="text-red-600 hover:scale-110"
                        title="Reject"
                        onClick={() => {
                          setActionType("REJECTED");
                          setShowRemarkInput(true);
                        }}
                      >
                        ❌
                      </button>
                    </div>
                  ) : (
                    <span
                      className="inline-block px-2 py-1 rounded-lg text-xs font-medium"
                      style={{
                        backgroundColor: selectedTask.statusColor || "#e5e7eb",
                      }}
                    >
                      {selectedTask.statusUpdates?.[
                        selectedTask.statusUpdates.length - 1
                      ]?.newStatus || selectedTask.statusName}
                    </span>
                  )}
                </span>

                {/* Remark Input */}
                {showRemarkInput && (
                  <div className="mt-2 dark:bg-gray-700 dark:text-white">
                    <textarea
                      rows="3"
                      value={remarkInput}
                      onChange={(e) => setRemarkInput(e.target.value)}
                      className="w-full border border-gray-300 rounded-lg p-2 text-sm dark:bg-gray-700 dark:text-white"
                      placeholder="Enter your remark..."
                    />
                    <div className="flex gap-2 mt-2">
                      <button
                        onClick={() =>
                          handleApproveOrReject(
                            selectedTask.taskId,
                            actionType,
                            remarkInput,
                          )
                        }
                        className="bg-[#673AB7] hover:bg-[#5e35a6] text-white text-sm px-4 py-1.5 rounded-lg"
                      >
                        Submit
                      </button>
                      <button
                        onClick={() => {
                          setRemarkInput("");
                          setShowRemarkInput(false);
                        }}
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 text-sm px-4 py-1.5 rounded-lg"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Status + Comments */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {/* Status Updates */}
              <div className="bg-gray-50 rounded-lg p-3 border dark:bg-gray-700 dark:text-white">
                <div className="flex justify-between items-center mb-2">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-800 dark:text-white">
                    📌 Status Updates
                  </h3>
                </div>
                <div className="max-h-[180px] overflow-y-auto pr-1.5 text-sm space-y-2">
                  {selectedTask.statusUpdates?.length > 0 ? (
                    <ul className="list-disc pl-4">
                      {selectedTask.statusUpdates.map((update, idx) => (
                        <li key={idx} className="mb-2">
                          <div className="flex flex-wrap gap-1">
                            <span className="font-medium">
                              {update.updatedByName}
                            </span>
                            <span>changed status from</span>
                            <span className="font-medium">
                              {update.oldStatus}
                            </span>
                            <span>to</span>
                            <span className="font-medium">
                              {update.newStatus}
                            </span>
                          </div>
                          <div className="text-gray-500 text-xs dark:text-white">
                            {new Date(update.updatedAt).toLocaleString()}
                          </div>
                          {update.remark && (
                            <div className="text-gray-500 text-xs italic mt-1 dark:text-white">
                              Remark: {update.remark}
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-gray-400 dark:text-white">
                      No status updates found.
                    </p>
                  )}
                </div>
              </div>

              {/* Comments */}
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 shadow-sm dark:bg-gray-800 dark:border-gray-700">
                {/* Header with comment count */}
                <div className="flex justify-between items-center mb-3">
                  <div className="flex items-center space-x-2">
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                      Comments
                    </h3>
                    <span className="bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-0.5 rounded-full dark:bg-purple-900 dark:text-purple-300">
                      {comments.length}
                    </span>
                  </div>
                  <button
                    onClick={() => setIsCommentBoxOpen(true)}
                    className="flex items-center space-x-1 text-[#673AB7] hover:text-purple-800 dark:text-purple-400 dark:hover:text-purple-300 transition-colors"
                  >
                    <FaPlusCircle className="text-lg" />
                    <span className="text-sm font-medium">Add Comment</span>
                  </button>
                </div>

                {/* Comments list */}
                <div className="space-y-4 max-h-64 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent dark:scrollbar-thumb-gray-600">
                  {comments.length > 0 ? (
                    comments.map((comment, idx) => (
                      <div
                        key={comment.commentId || idx}
                        className="group relative p-3 bg-white rounded-lg border border-gray-200 hover:shadow-sm transition-shadow dark:bg-gray-700 dark:border-gray-600"
                      >
                        {/* Comment content */}
                        {editingCommentId === (comment.commentId || idx) ? (
                          <div className="space-y-2">
                            <textarea
                              value={editedComment}
                              onChange={(e) => {
                                if (e.target.value.length <= 150) {
                                  setEditedComment(e.target.value);
                                }
                              }}
                              className="w-full p-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg outline-none transition-all duration-200 hover:border-[#673AB7] focus:ring-1 focus:ring-[#673AB7] focus:border-[#673AB7] dark:bg-gray-600 dark:border-gray-500 dark:text-white"
                              rows={3}
                              maxLength={150}
                              autoFocus
                            />
                            <div className="flex justify-between items-center">
                              <span className="text-xs text-gray-500 dark:text-gray-400">
                                {editedComment.length}/150 characters
                              </span>
                              {editedComment.length > 150 && (
                                <span className="text-xs text-red-500">
                                  Comment must not exceed 150 characters
                                </span>
                              )}
                            </div>
                            <div className="flex space-x-2">
                              <button
                                onClick={() => {
                                  if (editedComment.length > 150) return;
                                  handleUpdateComment(
                                    ticketDetails.ticketId,
                                    comment.commentId || idx,
                                    editedComment,
                                  );
                                }}
                                disabled={editedComment.length > 150}
                                className={`px-3 py-1.5 text-xs font-medium rounded-lg ${
                                  editedComment.length > 150
                                    ? "bg-gray-200 text-gray-500 cursor-not-allowed dark:bg-gray-600 dark:text-gray-400"
                                    : "bg-[#673AB7] text-white hover:bg-[#5e35a6]"
                                }`}
                              >
                                Update
                              </button>
                              <button
                                onClick={() => {
                                  setEditingCommentId(null);
                                  setEditedComment("");
                                }}
                                className="px-3 py-1.5 text-xs font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg dark:bg-gray-600 dark:text-gray-300 dark:hover:bg-gray-500"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <>
                            <p className="text-sm text-gray-700 dark:text-gray-300 break-words overflow-hidden">
                              {comment.content}
                            </p>
                            <div className="mt-2 flex items-center justify-between">
                              <div className="flex items-center space-x-2">
                                <span className="text-xs text-gray-500 dark:text-gray-400">
                                  {comment.userName}
                                </span>
                                <span className="text-xs text-gray-400 dark:text-gray-500">
                                  •
                                </span>
                                <span className="text-xs text-gray-500 dark:text-gray-400">
                                  {new Date(comment.createdAt).toLocaleString(
                                    "en-US",
                                    {
                                      month: "short",
                                      day: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    },
                                  )}
                                </span>
                              </div>
                              {comment.userId === user?.id && (
                                <div className="flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                  <button
                                    onClick={() => {
                                      setEditingCommentId(
                                        comment.commentId || idx,
                                      );
                                      setEditedComment(comment.content);
                                    }}
                                    className="text-[#673AB7] hover:text-[#5e35a6] p-1 rounded-full hover:bg-purple-50 dark:hover:bg-gray-600"
                                    title="Edit"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                      />
                                    </svg>
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleDeleteComment(
                                        comment.commentId || idx,
                                      )
                                    }
                                    className="text-red-500 hover:text-red-700 p-1 rounded-full hover:bg-red-50 dark:hover:bg-gray-600"
                                    title="Delete"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-6">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-12 w-12 mx-auto text-gray-400 dark:text-gray-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={1}
                          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                        />
                      </svg>
                      <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                        No comments yet. Be the first to comment!
                      </p>
                    </div>
                  )}
                </div>

                {/* Comment Input */}
                {isCommentBoxOpen && (
                  <div className="mt-3 dark:bg-gray-700 dark:text-white">
                    <textarea
                      rows="3"
                      value={newComment}
                      onChange={(e) => {
                        if (e.target.value.length <= 150) {
                          setNewComment(e.target.value);
                          setCommentLengthError("");
                        } else {
                          setCommentLengthError(
                            "comment must not exceed 150 characters",
                          );
                        }
                      }}
                      className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-purple-400 text-sm dark:bg-gray-700"
                      placeholder="Write your comment..."
                    />
                    <div className="flex justify-between items-center mt-1">
                      <span className="text-xs text-gray-500 dark:text-gray-300">
                        {newComment.length}/150 characters
                      </span>
                      {commentLengthError && (
                        <span className="text-xs text-red-500">
                          {commentLengthError}
                        </span>
                      )}
                    </div>
                    <button
                      onClick={handleAddComment}
                      disabled={newComment.length > 150}
                      className={`mt-2 bg-[#673AB7] hover:bg-[#5e35a6] text-white text-sm px-4 py-1.5 rounded-lg transition ${
                        newComment.length > 150
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                    >
                      Submit
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {editModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-2 sm:p-4 animate-fade-in">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl h-[95vh] flex flex-col">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10 dark:bg-gray-700 dark:text-white">
              <h2 className="text-lg sm:text-xl font-bold text-gray-800 dark:text-white">
                Edit Task
              </h2>
              <button
                onClick={() => setEditModalOpen(false)}
                className="p-2 rounded-full hover:bg-gray-100 focus:outline-none"
                aria-label="Close modal"
              >
                <XMarkIcon className="h-6 w-6 text-gray-500 hover:text-gray-700 transition" />
              </button>
            </div>

            {/* Form Body (scrollable if needed) */}
            <div className="overflow-y-auto px-4 py-2 sm:p-4 flex-grow dark:bg-gray-700 dark:text-white">
              <form
                id="editTaskForm"
                onSubmit={handleUpdateSubmit}
                className="space-y-3"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 dark:bg-gray-700 dark:text-white">
                  {/* Subject */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-white">
                      Subject
                    </label>
                    <input
                      type="text"
                      name="subject"
                      value={editedTask.subject || ""}
                      onChange={handleInputChange}
                      className="w-full p-2 border border-gray-300 rounded-lg dark:text-white dark:bg-gray-700"
                      required
                    />
                  </div>

                  {/* Priority */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-white">
                      Priority
                    </label>
                    <select
                      name="priority"
                      value={editedTask.priority || "Low"}
                      onChange={handleInputChange}
                      className="w-full p-2 border border-gray-300 rounded-lg dark:text-white dark:bg-gray-700"
                    >
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                    </select>
                  </div>

                  {/* Label */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-white">
                      Label (Optional)
                    </label>
                    <select
                      name="labelName"
                      value={editedTask.labelName || ""}
                      onChange={handleLabelChange}
                      className="w-full p-2 border border-gray-300 rounded-lg dark:text-white dark:bg-gray-700"
                    >
                      <option value="">Select Label</option>
                      {labels.map((label) => (
                        <option key={label.id} value={label.name}>
                          {label.name}
                        </option>
                      ))}
                    </select>
                    {editedTask.labelColor && (
                      <div
                        className="w-6 h-3 mt-1 rounded-lg"
                        style={{ backgroundColor: editedTask.labelColor }}
                      ></div>
                    )}
                  </div>

                  {/* End Date */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-white">
                      End Date
                    </label>
                    <input
                      type="date"
                      name="endDate"
                      value={editedTask.endDate || ""}
                      onChange={handleInputChange}
                      className="w-full p-2 border border-gray-300 rounded-lg dark:text-white dark:bg-gray-700"
                    />
                  </div>

                  {/* File Upload */}
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 dark:text-white">
                      Update File (Optional)
                    </label>
                    <input
                      type="file"
                      name="file"
                      onChange={(e) =>
                        setEditedTask({
                          ...editedTask,
                          file: e.target.files[0],
                        })
                      }
                      className="w-full p-2 text-sm border border-gray-300 rounded-lg file:mr-2 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-purple-50 file:text-[#5e35a6] hover:file:bg-purple-100 dark:text-white dark:bg-gray-700"
                    />
                  </div>
                </div>

                {/* Assign To */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-white">
                    Assign To
                  </label>
                  <Select
                    isMulti
                    name="assignedToJson"
                    options={users.map((user) => ({
                      value: user.id,
                      label: `${user.fname} ${user.lname}`,
                    }))}
                    value={
                      editedTask.assignedToJson
                        ? JSON.parse(editedTask.assignedToJson).map((user) => ({
                            value: user.id,
                            label: user.name,
                          }))
                        : []
                    }
                    onChange={handleAssignedUsersChange}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "42px",
                        padding: "2px 4px",
                        borderRadius: "0.375rem", // Tailwind rounded-lg
                        borderColor: "#d1d5db", // Tailwind gray-300
                        backgroundColor:
                          document.documentElement.classList.contains("dark")
                            ? "#374151" // Tailwind gray-700
                            : "white",
                        color: document.documentElement.classList.contains(
                          "dark",
                        )
                          ? "white"
                          : "black",
                        boxShadow: state.isFocused
                          ? "0 0 0 1px #60a5fa"
                          : "none", // Tailwind purple-400
                        "&:hover": {
                          borderColor: "#9ca3af", // Tailwind gray-400
                        },
                      }),
                      menu: (base) => ({
                        ...base,
                        borderRadius: "0.375rem",
                        marginTop: 4,
                        backgroundColor:
                          document.documentElement.classList.contains("dark")
                            ? "#1f2937" // Tailwind gray-800
                            : "white",
                        color: document.documentElement.classList.contains(
                          "dark",
                        )
                          ? "white"
                          : "black",
                      }),
                      option: (base, { isFocused, isSelected }) => ({
                        ...base,
                        backgroundColor: isFocused
                          ? document.documentElement.classList.contains("dark")
                            ? "#4b5563" // Tailwind gray-600
                            : "#f3f4f6" // Tailwind gray-100
                          : isSelected
                            ? "#60a5fa" // Tailwind purple-400
                            : "transparent",
                        color: document.documentElement.classList.contains(
                          "dark",
                        )
                          ? "white"
                          : "black",
                        cursor: "pointer",
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor:
                          document.documentElement.classList.contains("dark")
                            ? "#6b7280" // Tailwind gray-500
                            : "#e5e7eb", // Tailwind gray-200
                        borderRadius: "0.375rem",
                        padding: "2px 6px",
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: document.documentElement.classList.contains(
                          "dark",
                        )
                          ? "white"
                          : "black",
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: "#ef4444", // Tailwind red-500
                        ":hover": {
                          backgroundColor: "#f87171", // red-400
                          color: "white",
                        },
                      }),
                    }}
                  />
                </div>

                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
                    Participant Email
                  </label>
                  <div className="flex gap-2">
                    <input
                      type="email"
                      value={participantEmail}
                      onChange={(e) => setParticipantEmail(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-lg dark:bg-gray-700"
                      placeholder="Add participant email"
                    />
                    <button
                      type="button"
                      onClick={handleAddParticipant}
                      className="px-3 py-2 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6]"
                    >
                      Add
                    </button>
                  </div>
                </div>

                {/* List of Added Participants */}
                {participants.length > 0 && (
                  <div className="mt-2 space-y-1">
                    {participants.map((participant, index) => {
                      const email = Array.isArray(participant)
                        ? participant[1] || participant[0]
                        : participant;
                      return (
                        <div
                          key={index}
                          className="flex items-center justify-between bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-lg"
                        >
                          <span className="text-sm text-gray-800 dark:text-white">
                            {email}
                          </span>
                          <button
                            type="button"
                            onClick={() => {
                              setParticipants((prev) =>
                                prev.filter((_, i) => i !== index),
                              );
                            }}
                            className="text-red-500 hover:text-red-700 text-sm"
                            title="Remove"
                          >
                            ❌
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Description */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-white">
                    Description
                  </label>
                  <textarea
                    name="description"
                    value={editedTask.description || ""}
                    onChange={handleInputChange}
                    required
                    className="w-full p-2 border border-gray-300 rounded-lg min-h-[80px] dark:text-white dark:bg-gray-700"
                  />
                </div>
              </form>
            </div>

            {/* Footer Buttons */}
            <div className="flex justify-end gap-3 border-t px-4 py-3 dark:text-white dark:bg-gray-700">
              <button
                type="button"
                onClick={() => setEditModalOpen(false)}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition"
              >
                Cancel
              </button>
              <button
                type="submit"
                form="editTaskForm"
                // onClick={handleUpdateSubmit}
                className="px-4 py-2 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6] transition"
              >
                Update Task
              </button>
            </div>
          </div>
        </div>
      )}
      {showNotifyModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 backdrop-blur-sm animate-fade-in">
          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md text-center dark:bg-gray-900 dark:text-white">
            <div className="flex justify-end">
              <button
                type="button"
                onClick={() => {
                  setShowNotifyModal?.(false);
                }}
                className="text-gray-600 hover:text-red-600 text-xl font-bold"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            <h2 className="text-lg font-semibold mb-4">
              Notification Preference
            </h2>
            <p className="mb-4">
              How would you like to notify{" "}
              <span className="font-bold">{pendingParticipant.email}</span>?
            </p>
            <div className="flex justify-around gap-4">
              <button
                onClick={() => confirmParticipant("both")}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
              >
                Notification + Email
              </button>
              <button
                onClick={() => confirmParticipant("email")}
                className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600"
              >
                Email Only
              </button>
            </div>
          </div>
        </div>
      )}
      {isResponseModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in">
          <div className="bg-white p-6 rounded-lg w-96 shadow-xl relative dark:bg-gray-700 dark:text-white">
            <h2 className="text-xl font-semibold mb-4">Add Response</h2>
            <textarea
              name="content"
              value={responseData.content}
              onChange={handleInputChange}
              placeholder="Type your response..."
              className="w-full border p-2 rounded-lg mb-4 dark:bg-gray-700 dark:text-white"
            />
            <input type="file" onChange={handleFileChange} className="mb-4" />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setIsResponseModalOpen(false)}
                className="bg-gray-300 px-4 py-2 rounded-lg hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleResponseSubmit}
                className="bg-[#673AB7] text-white px-4 py-2 rounded-lg hover:bg-[#5e35a6]"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {isViewModalOpen && selectedTask && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 animate-fade-in">
          <div className="bg-white rounded-2xl w-full max-w-3xl p-6 shadow-2xl relative dark:bg-gray-700 dark:text-white">
            <h2 className="text-xl font-bold text-[#673AB7] mb-6 border-b pb-2">
              {selectedTask.subject}
            </h2>

            <div className="space-y-5 max-h-[70vh] custom-scroll pr-2">
              {taskResponses.length === 0 ? (
                <p className="text-gray-500 italic">No responses available.</p>
              ) : (
                taskResponses.map((res, idx) => (
                  <div
                    key={idx}
                    className="bg-gray-50 border border-gray-200 rounded-lg p-2 shadow-sm dark:bg-gray-700 dark:text-white"
                  >
                    <div className="flex justify-between dark:bg-gray-700 dark:text-white">
                      <div>
                        <p className="text-sm font-semibold text-gray-700 darK:text-white">
                          {res.userName}
                        </p>
                        <p className="text-sm text-gray-800 mt-1 dark:text-white">
                          {res.content}
                        </p>
                        <p className="text-xs text-gray-500 mt-1 dark:text-white">
                          Posted on: {new Date(res.createdAt).toLocaleString()}
                        </p>
                      </div>

                      <div className="flex gap-3 items-center text-lg ">
                        <button
                          onClick={() => toggleCommentBox(res.id)}
                          title="Add Comment"
                          className="text-gray-500 hover:text-[#673AB7]"
                        >
                          <FaCommentAlt />
                        </button>

                        {res.userId === user?.id && (
                          <>
                            <button
                              title="Edit Response"
                              onClick={() => handleEditResponse(res)}
                              className="text-[#673AB7] hover:text-[#5e35a6]"
                            >
                              <FaEdit />
                            </button>
                            <button
                              title="Delete Response"
                              onClick={() => handleDeleteResponse(res.id)}
                              className="text-red-500 hover:text-red-700"
                            >
                              <FaTrash />
                            </button>
                          </>
                        )}

                        {res.attachment && (
                          <>
                            <button
                              title="View Attachment"
                              onClick={() => handleViewFile(res)}
                              className="text-green-600 hover:text-green-800"
                            >
                              <FaEye />
                            </button>
                            <button
                              title="Download Attachment"
                              onClick={() => handleDownloadFile(res)}
                              className="text-gray-600 hover:text-gray-800"
                            >
                              <FaDownload />
                            </button>
                          </>
                        )}
                      </div>
                    </div>

                    {/* Comments */}
                    <div className="mt-4 space-y-3">
                      {res.comments?.map((comment) => (
                        <div
                          key={comment.commentId}
                          className="bg-white dark:bg-gray-800 dark:text-white border-l-4 border-[#673AB7] p-3 rounded-lg shadow-sm max-w-full"
                        >
                          <p className="text-sm break-words whitespace-pre-wrap">
                            <span className="font-semibold">
                              {comment.userName || "Unknown"}:
                            </span>{" "}
                            {comment.content || "No comment text"}
                          </p>
                          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                            {new Date(comment.createdAt).toLocaleString()}
                          </p>

                          {comment.userId === user?.id && (
                            <div className="flex gap-3 mt-2 flex-wrap">
                              <button
                                onClick={() =>
                                  handleEditComment(res.id, comment)
                                }
                                className="text-[#673AB7] hover:text-purple-800 text-sm flex items-center gap-1"
                                title="Edit Comment"
                              >
                                <FaEdit /> <span>Edit</span>
                              </button>
                              <button
                                onClick={() =>
                                  handleDeleteResponseComment(
                                    res.id,
                                    comment.commentId,
                                  )
                                }
                                className="text-red-600 hover:text-red-800 text-sm flex items-center gap-1"
                                title="Delete Comment"
                              >
                                <FaTrash /> <span>Delete</span>
                              </button>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* Comment Input */}
                    {showCommentBoxId === res.id && (
                      <div className="mt-3 dark:bg-gray-700 dark:text-white">
                        <textarea
                          rows={2}
                          className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] text-sm dark:bg-gray-700 dark:text-white"
                          value={commentInput}
                          onChange={(e) => {
                            if (e.target.value.length <= 150) {
                              setCommentInput(e.target.value);
                            }
                          }}
                          placeholder="Write your comment..."
                          maxLength={150}
                        ></textarea>
                        <div className="flex justify-between items-center mt-1">
                          <span className="text-xs text-gray-500 dark:text-gray-300">
                            {commentInput.length}/150 characters
                          </span>
                          {commentInput.length > 150 && (
                            <span className="text-xs text-red-500">
                              comment must not exceed 150 characters
                            </span>
                          )}
                        </div>
                        <div className="flex justify-end mt-2 gap-2">
                          <button
                            onClick={() => toggleCommentBox(res.id)}
                            className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 dark:text-white"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => submitComment(res.id)}
                            disabled={commentInput.length > 150}
                            className={`px-4 py-1 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6] text-sm ${
                              commentInput.length > 150
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            {editingComment ? "Update" : "Comment"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>

            <button
              onClick={() => {
                setIsViewModalOpen(false);
                setShowCommentBoxId(null);
                setCommentInput("");
                setEditingComment(null);
              }}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {responseFileModalOpen && currentResponseFile && (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in">
          <div className="relative bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
            <div className="flex justify-between items-center p-4 border-b dark:bg-gray-700 dark:text-white">
              <h3 className="text-lg font-medium">
                {currentResponseFile.name}
              </h3>
              <button
                onClick={() => {
                  setResponseFileModalOpen(false);
                  URL.revokeObjectURL(currentResponseFile.url);
                  setCurrentResponseFile(null);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>

            <div className="flex-1 overflow-auto p-4 flex items-center justify-center">
              {currentResponseFile.type === "image" ? (
                <img
                  src={currentResponseFile.url}
                  alt="File preview"
                  className="max-w-full max-h-[70vh] object-contain"
                />
              ) : currentResponseFile.type === "pdf" ? (
                <iframe
                  src={`${currentResponseFile.url}#toolbar=0`}
                  className="w-full h-[70vh] border-none"
                  title="PDF preview"
                />
              ) : currentResponseFile.type === "video" ? (
                <video controls className="w-full max-h-[70vh]">
                  <source
                    src={currentResponseFile.url}
                    type={`video/${currentResponseFile.name.split(".").pop()}`}
                  />
                  Your browser does not support the video tag.
                </video>
              ) : currentResponseFile.type === "audio" ? (
                <audio controls className="w-full">
                  <source
                    src={currentResponseFile.url}
                    type={`audio/${currentResponseFile.name.split(".").pop()}`}
                  />
                  Your browser does not support the audio element.
                </audio>
              ) : currentResponseFile.type === "office" ? (
                <iframe
                  src={getOfficeViewerUrl(currentResponseFile.url)}
                  className="w-full h-[70vh] border-none"
                  title="Office document preview"
                  allowFullScreen
                />
              ) : currentResponseFile.type === "text" ? (
                <iframe
                  src={currentResponseFile.url}
                  className="w-full h-[70vh] border-none"
                  title="Text preview"
                />
              ) : (
                <div className="text-center p-4">
                  <p className="text-gray-500 mb-4">
                    Preview not available for this file type
                  </p>
                  <button
                    onClick={() =>
                      handleDownloadFile({
                        id: taskResponses.find(
                          (r) => r.attachment === currentResponseFile.name,
                        )?.id,
                        attachment: currentResponseFile.name,
                      })
                    }
                    className="px-4 py-2 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6]"
                  >
                    Download File
                  </button>
                </div>
              )}
            </div>

            <div className="flex justify-end p-4 border-t">
              <button
                onClick={() =>
                  handleDownloadFile({
                    id: taskResponses.find(
                      (r) => r.attachment === currentResponseFile.name,
                    )?.id,
                    attachment: currentResponseFile.name,
                  })
                }
                className="px-4 py-2 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6]"
              >
                Download
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && taskToDelete && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/60 z-50 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-lg p-6 shadow-md w-full max-w-sm dark:bg-gray-700 dark:text-white">
            <h2 className="text-lg font-semibold text-gray-800 mb-4 dark:text-white">
              Confirm Delete
            </h2>
            <p className="text-gray-600 mb-6 dark:text-white">
              Are you sure you want to delete this task?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 dark:text-white dark:hover:bg-gray-500"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                onClick={() => handleDeleteTask(taskToDelete.taskId)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {showAttachmentModal && (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 animate-fade-in">
          <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-xl p-4 sm:p-6 w-full max-w-full sm:max-w-4xl h-[90vh] flex flex-col dark:bg-gray-700 dark:text-white">
            <div className="flex justify-between items-center mb-4 dark:bg-gray-700 dark:text-white">
              <h3 className="text-lg font-medium text-gray-900 dark:text-white truncate max-w-[80%]">
                {attachmentFilename}
              </h3>
              <button
                onClick={() => {
                  setShowAttachmentModal(false);
                  if (currentAttachment) {
                    URL.revokeObjectURL(currentAttachment);
                  }
                }}
                className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 p-1"
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>

            <div className="flex-1 flex flex-col items-center overflow-hidden dark:bg-gray-700 dark:text-white">
              {attachmentType === "image" ? (
                <img
                  src={currentAttachment}
                  alt="Attachment preview"
                  className="max-h-full max-w-full object-contain"
                />
              ) : attachmentType === "video" ? (
                <video controls className="w-full h-full max-h-[70vh]">
                  <source
                    src={currentAttachment}
                    type={`video/${attachmentFilename.split(".").pop()}`}
                  />
                  Your browser does not support the video tag.
                </video>
              ) : attachmentType === "audio" ? (
                <audio controls className="w-full max-w-md">
                  <source
                    src={currentAttachment}
                    type={`audio/${attachmentFilename.split(".").pop()}`}
                  />
                  Your browser does not support the audio element.
                </audio>
              ) : attachmentType === "pdf" ? (
                <iframe
                  src={`${currentAttachment}#toolbar=0`}
                  className="w-full h-full min-h-[50vh] border-none"
                  title="PDF preview"
                />
              ) : ["word", "excel", "powerpoint"].includes(attachmentType) ? (
                <iframe
                  src={getOfficeViewerUrl(currentAttachment)}
                  className="w-full h-full min-h-[50vh] border-none"
                  title={`${attachmentType} document preview`}
                  allowFullScreen
                />
              ) : attachmentType === "text" ? (
                <iframe
                  src={currentAttachment}
                  className="w-full h-full min-h-[50vh] border-none"
                  title="Text preview"
                />
              ) : (
                <div className="flex flex-col items-center justify-center h-full p-4 dark:bg-gray-700 dark:text-white">
                  <p className="text-gray-500 mb-4 text-center">
                    Preview not available for this file type
                  </p>
                  <button
                    onClick={() => handleDownloadAttachment(selectedTask)}
                    className="px-4 py-2 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6]"
                  >
                    Download File
                  </button>
                </div>
              )}
            </div>

            <div className="mt-4 flex justify-end dark:bg-gray-700 dark:text-white">
              <button
                onClick={() => handleDownloadAttachment(selectedTask)}
                className="px-4 py-2 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6]"
              >
                Download
              </button>
            </div>
          </div>
        </div>
      )}

      {statusUpdateModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 dark:bg-gray-700 dark:text-white">
            <h2 className="text-xl font-bold mb-4 dark:text-white">
              Update Task Status
            </h2>

            <div className="mb-4">
              <label className="block text-gray-700 mb-2 dark:text-white">
                New Status:
              </label>
              <div className="p-2 bg-gray-100 rounded-lg border dark:bg-gray-700 dark:text-white">
                {selectedStatusUpdate.newStatus}
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-2 dark:text-white">
                Remark:
              </label>
              <textarea
                className="w-full p-2 border rounded-lg dark:bg-gray-700 dark:text-white"
                rows="4"
                placeholder="Enter remark for status change..."
                value={selectedStatusUpdate.remark}
                onChange={(e) =>
                  setSelectedStatusUpdate((prev) => ({
                    ...prev,
                    remark: e.target.value,
                  }))
                }
              />
            </div>

            <div className="flex justify-end space-x-2">
              <button
                className="px-4 py-2 bg-gray-300 rounded-lg"
                onClick={() => setStatusUpdateModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6]"
                onClick={handleStatusUpdateSubmit}
              >
                Update Status
              </button>
            </div>
          </div>
        </div>
      )}
      {editModalData && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 animate-fade-in">
          <div className="bg-white rounded-xl w-full max-w-xl p-6 shadow-xl relative dark:bg-gray-700 dark:text-white">
            <h2 className="text-xl font-semibold text-[#673AB7] mb-4 dark:text-dark">
              Edit Response
            </h2>

            <label className="block mb-2 text-gray-700 font-medium dark:text-white">
              Content
              <textarea
                value={updatedContent}
                onChange={(e) => setUpdatedContent(e.target.value)}
                rows={4}
                className="w-full p-2 mt-1 border rounded-lg dark:bg-gray-700 dark:text-white"
              />
            </label>

            <label className="block mb-4 text-gray-700 font-medium dark:text-white">
              Upload New File (optional)
              <input
                type="file"
                onChange={(e) => setUpdatedFile(e.target.files[0])}
                className="w-full mt-1 border dark:bg-gray-700 dark:text-white"
              />
            </label>

            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                onClick={() => setEditModalData(null)}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6]"
                onClick={handleUpdateResponse}
              >
                Update
              </button>
            </div>

            <button
              onClick={() => setEditModalData(null)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              ✖
            </button>
          </div>
        </div>
      )}
      {taskDetailsModalOpen && selectedTask && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-fade-in">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="p-4 border-b dark:border-gray-700 flex justify-between items-center">
              <h2 className="text-xl font-bold text-gray-800 dark:text-white">
                Task Details
              </h2>
              <button
                onClick={() => setTaskDetailsModalOpen(false)}
                className="text-gray-500 hover:text-gray-700 dark:text-white"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>

            <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Basic Info */}
              <div className="space-y-2">
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white border-b pb-2">
                  Basic Information
                </h3>
                <div>
                  <span className="font-medium text-gray-700 dark:text-gray-300">
                    Subject:
                  </span>
                  <span className="ml-2 dark:text-white">
                    {selectedTask.subject}
                  </span>
                </div>
                <div>
                  <span className="font-medium text-gray-700 dark:text-gray-300">
                    Priority:
                  </span>
                  <span className="ml-2 dark:text-white">
                    {selectedTask.priority}
                  </span>
                </div>
                <div>
                  <span className="font-medium text-gray-700 dark:text-gray-300">
                    Status:
                  </span>
                  <span className="ml-2 dark:text-white">
                    {selectedTask.statusName}
                  </span>
                </div>
                <div>
                  <span className="font-medium text-gray-700 dark:text-gray-300">
                    Start Date:
                  </span>
                  <span className="ml-2 dark:text-white">
                    {/* {selectedTask.startDate} */}

                    {formatDate(selectedTask.startDate)}
                  </span>
                </div>
                <div>
                  <span className="font-medium text-gray-700 dark:text-gray-300">
                    End Date:
                  </span>
                  <span className="ml-2 dark:text-white">
                    {/* {selectedTask.endDate} */}
                    {formatDate(selectedTask.endDate)}
                  </span>
                </div>
              </div>

              {/* Assignment Info */}
              <div className="space-y-2">
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white border-b pb-2">
                  Assignment
                </h3>
                <div>
                  <span className="font-medium text-gray-700 dark:text-gray-300">
                    Created By:
                  </span>
                  <span className="ml-2 dark:text-white">
                    {selectedTask.createdByName}
                  </span>
                </div>
                <div>
                  <span className="font-medium text-gray-700 dark:text-gray-300">
                    Assigned To:
                  </span>
                  <div className="ml-2 dark:text-white">
                    {selectedTask.assignedTo?.map((assignee, idx) => (
                      <span key={idx}>
                        {assignee.name}
                        {idx < selectedTask.assignedTo.length - 1 ? ", " : ""}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Description */}
              <div className="md:col-span-2">
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white border-b pb-2">
                  Description
                </h3>
                <div className="mt-2 p-2 bg-gray-50 dark:bg-gray-700 rounded-lg">
                  <pre className="whitespace-pre-wrap dark:text-white">
                    {selectedTask.description || "No description provided"}
                  </pre>
                </div>
              </div>

              {/* Status Updates */}
              {selectedTask.statusUpdates?.length > 0 && (
                <div className="md:col-span-2">
                  <h3 className="text-lg font-semibold text-gray-800 dark:text-white border-b pb-2">
                    Status History
                  </h3>
                  <div className="mt-2 space-y-2">
                    {selectedTask.statusUpdates.map((update, idx) => (
                      <div
                        key={idx}
                        className="p-2 border-b dark:border-gray-700"
                      >
                        <div className="flex flex-wrap gap-1">
                          <span className="font-medium">
                            {update.updatedByName}
                          </span>
                          <span>changed status from</span>
                          <span className="font-medium">
                            {update.oldStatus || "None"}
                          </span>
                          <span>to</span>
                          <span className="font-medium">
                            {update.newStatus}
                          </span>
                        </div>
                        <div className="text-sm text-gray-500 dark:text-gray-400">
                          {formatDate(
                            new Date(update.updatedAt).toLocaleString(),
                          )}
                        </div>
                        {update.remark && (
                          <div className="text-sm text-gray-600 dark:text-gray-300 mt-1">
                            <span className="font-medium">Remark:</span>{" "}
                            {update.remark}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}